"use strict";

var quiz;
var quizRetractable;
var boolNoMounting = false;
var plusIcon = '<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><g stroke="#37312F" fill="none" fill-rule="evenodd"> <path d="M5 0v10M10 5H0"/></g></svg>';
var minusIcon = '<svg width="10" height="1" viewBox="0 0 10 1" xmlns="http://www.w3.org/2000/svg"><path d="M10 .5H0" stroke="#37312F" fill="none" fill-rule="evenodd"/></svg>';
var quizStoreData = {};
var quizRetractableCoversStoreData = {};
$(document).ready(function ($) {
  /*Intro screen click*/
  /* $(".js__step").click(function (e) {
       var step = $(this).attr("data-intro-step");
       $(".builder-section").removeClass("active");
       $(".builder-section").hide();
       $(".js__builder-section-" + step).addClass("active");
       $(".js__builder-section-" + step).show();
       $("html,body").animate(
         {
           scrollTop: $(".builder").offset().top - 200,
         },
         500
       );
     });*/
  var steps = ["truck", "years", "mounting", "brackets", "addons", "summary"];
  try {
    $.each(quizProdLib, function (key, value) {
      var truckID = value.type.replace(/ /g, "-");
      var productName = value.type;
      $.each(value.Years, function (key, value) {
        $.each(value.option, function (key, value) {
          var variantID = value.variantID;
          $.each(prodBuilderProducts, function (key, values) {
            if (values.variantID == variantID) {
              productName = values.productName;
            }
          });
        });
      });
      $(".js__quiz-truck").append('<li class="js__builder-truck-type"><input type="radio" id="' + truckID + '" name="truck-group" value="' + value.type + '" ><label for="' + truckID + '" class="flex-align-center"><div class="relative image-section"><img src="' + value.image + '"  alt=""></div><p>' + productName + "</p></label></li>");
    });
  } catch {}
  setTimeout(function () {
    try {
      if (localStorage.getItem("builderData") != null) {
        console.log("if");
        var retrievedData = localStorage.getItem("builderData");
        quizStoreData = JSON.parse(retrievedData);
        $(".js__builder-truck-type").each(function (index) {
          if ($(this).children("input").val() == quizStoreData["truck"]) {
            console.log("if22");
            $(this).children("input").attr("checked", "checked");
            $(this).click();
          }
        });
      }
    } catch {}
    try {
      if (localStorage.getItem("builderRetractableCoversData") != null) {
        console.log("if");
        var retrievedData = localStorage.getItem("builderRetractableCoversData");
        quizRetractableCoversStoreData = JSON.parse(retrievedData);
        $(".js__builder-retractable-covers-truck-type").each(function (index) {
          if ($(this).children("input").val() == quizRetractableCoversStoreData["truck"]) {
            console.log("if22");
            $(this).children("input").attr("checked", "checked");
            $(this).click();
          }
        });
      }
    } catch {}
  }, 1000);
  try {
    $.each(quizAccessoriesLib, function (key, value) {
      var productName = value.name;
      var productVariant = value.variantId;
      var productPrice = 0;
      var productType = "";
      productType = value.type;
      var productHeight = value.height;
      var productImage = value.image;
      var product8InchImage = value.eightInchImage;
      var product5InchImage = value.fiveInchImage;
      var product8InchDualImage = value.eightInchDualImage;
      var product5InchDualImage = value.fiveInchDualImage;
      if (productType == undefined) {
        productType = "";
      }
      if (productHeight == undefined) {
        productHeight = "";
      }
      if (product8InchImage == undefined) {
        product8InchImage = "";
      }
      if (product5InchImage == undefined) {
        product5InchImage = "";
      }
      if (product8InchDualImage == undefined) {
        product8InchDualImage = "";
      }
      if (product5InchDualImage == undefined) {
        product5InchDualImage = "";
      }
      var duplicateBool = false;
      $.each(prodBuilderAddons, function (key, values) {
        if (duplicateBool == false) if (values.variantID == productVariant) {
          if (productImage == "") {
            productImage = values.productImage;
          }
          duplicateBool = true;
          productPrice = values.price;
          var productFormatPrice = productPrice / 100;
          productFormatPrice = formatter.format(productFormatPrice);
          var Quanatity = '<div class="cart-quantity-outer " style=" display:none"> <a id="plus' + productVariant + '"  class="js__builder-quantity minus-qty">' + minusIcon + '</a> <input aria-label="Quantity" id="' + productVariant + '" readonly="readonly" class="quantity-selector" id="input' + productVariant + '"  onkeydown="return isNumeric(event);" value="1" type="text" > <a id="minus' + productVariant + '"    class="js__builder-quantity plus-qty">' + plusIcon + "</a> </div>";
          if (productName.indexOf("Molle Panel") > -1) {
            if (productName == "BillieBars, Mid Height Molle Panel (QTY 1)") {
              $(".js__quiz-accessories").append('<li data-image-5inch="" data-image-8inch="' + product8InchImage + '"   data-image-5inchdual="" data-image-8inchdual="' + product8InchDualImage + '"class="js__molle-panel js__molle-panel-8inch ' + productType + ' ' + productHeight + '" data-variant="' + productVariant + '" data-price="' + productPrice + '"> <input type="checkbox" id="accessories' + productVariant + '" name="accessories-group"><label for="accessories' + productVariant + '" class="flex-align-center"><div class="relative image-section"><img src="' + productImage + '" alt="">  </div>    <div class="content"><p>' + productName + "</p><span> " + productFormatPrice + "</span></div></label>" + Quanatity + "</li>");
            } else {
              $(".js__quiz-accessories").append('<li data-image-5inch="' + product5InchImage + '" data-image-8inch="' + product8InchImage + '"  data-image-5inchdual="' + product5InchDualImage + '" data-image-8inchdual="' + product8InchDualImage + '" class="js__molle-panel js__molle-panel-5inch ' + productType + ' ' + productHeight + '" data-variant="' + productVariant + '" data-price="' + productPrice + '"> <input type="checkbox" id="accessories' + productVariant + '" name="accessories-group"><label for="accessories' + productVariant + '" class="flex-align-center"><div class="relative image-section"><img src="' + productImage + '" alt="">  </div>    <div class="content"><p>' + productName + "</p><span> " + productFormatPrice + "</span></div></label>" + Quanatity + "</li>");
            }
          } else {
            $(".js__quiz-accessories").append('<li class="' + productType + ' ' + productHeight + '" data-image-5inch="' + product5InchImage + '" data-image-8inch="' + product8InchImage + '" data-variant="' + productVariant + '" data-price="' + productPrice + '"> <input type="checkbox" id="accessories' + productVariant + '" name="accessories-group"><label for="accessories' + productVariant + '" class="flex-align-center"><div class="relative image-section"><img src="' + productImage + '" alt="">  </div>    <div class="content"><p>' + productName + "</p><span> " + productFormatPrice + "</span></div></label>" + Quanatity + "</li>");
          }
        }
      });
    });
  } catch {}
  try {
    $.each(quizHardwareLib, function (key, value) {
      var productName = value.name;
      var productVariant = value.variantId;
      var productPrice = 0;
      var productImage = value.image;
      $.each(prodBuilderAddons, function (key, values) {
        if (values.variantID == productVariant) {
          productPrice = values.price;
          var productFormatPrice = productPrice / 100;
          productFormatPrice = formatter.format(productFormatPrice);
          $(".js__quiz-hardware").append('<li data-variant="' + productVariant + '" data-price="' + productPrice + '"> <input type="checkbox" id="hardware' + productVariant + '" name="hardware-group"><label for="hardware' + productVariant + '" class="flex-align-center"><div class="relative image-section"><img src="' + productImage + '" alt="">  </div>    <div class="content"><p>' + productName + "</p><span> " + productFormatPrice + "</span></div></label></li>");
        }
      });
    });
  } catch {}

  /**/
  quiz = {};
  /*Truck type click*/
  $(document).on("click", ".js__builder-truck-type", function () {
    console.log("click");
    console.log($(this).children("input").val());
    if ($(this).children("input:checked").val() == "Custom") {
      window.location.href = "/collections/billie-bars/products/billiebars-custom-sets";
    } else {
      if ($(this).children("input:checked").val() != quiz["truck"]) {
        boolNoMounting = false;
        var truckType = $(this).children("input").val();
        var truckTypeName = $(this).children("label").children("p").html();
        console.log("else");
        console.log(truckType);
        $(".js__builder-total-section").hide();
        $(".js__year-options").empty();
        $(".js__brackets-options").empty();
        $(".js__mounting-brackets").empty();
        quiz = null;
        quiz = {};
        quiz["truck"] = truckType;
        $(".js__selected-truck").html("For " + truckType);
        $(".js__summary-truck").html(truckTypeName);
        $.each(quizProdLib, function (key, value) {
          if (truckType == value.type) {
            $.each(value.Years, function (key, value) {
              //alert(value.year);
              var yearID = value.year.replace(/ /g, "-");
              var yearValue = value.year.replace(/"/g, "~");
              yearID = yearID.replace(/"/g, "-");
              $(".js__year-options").append('<li  class="js__builder-year"> <input type="radio" id="' + yearID + '" name="year" value="' + yearValue + '" >  <label class="custom-checkbox flex-align-center" for="' + yearID + '">' + value.year + "</label></li>");
            });
            $(".js__year-options").append('<li  class="js__builder-year"> <input type="radio" id="builder-other-year" name="year" value="Other" >  <label class="custom-checkbox flex-align-center" for="builder-other-year">Other</label></li>');
          }
        });
        //localStorage.setItem("builderData", quiz);
        // localStorage.setItem("builderData", JSON.stringify(quiz));

        // save to localStorage
        try {
          if (localStorage.getItem("builderData") != null) {
            if (truckType != quizStoreData["truck"]) {
              localStorage.setItem("builderData", JSON.stringify(quiz));
            }
          } else {
            localStorage.setItem("builderData", JSON.stringify(quiz));
          }
          $(".js__builder-year").each(function (index) {
            if ($(this).children("input").val().replace(/~/g, '"') == quizStoreData["years"]) {
              console.log("if22");
              $(this).children("input").attr("checked", "checked");
              $(this).click();
            }
          });
        } catch {}
      }
    }
  });
  /*Truck Year click*/
  $(document).on("click", ".js__builder-year", function () {
    if ($(this).children("input:checked").val() != quiz["years"]) {
      boolNoMounting = false;
      var truckYear = $(this).children("input").val().replace(/~/g, '"');
      $(".js__brackets-options").empty();
      $(".js__mounting-brackets").empty();
      $(".js__builder-total-section").hide();
      quiz["years"] = truckYear;
      $.each(quizProdLib, function (key, value) {
        if (quiz["truck"] == value.type) {
          $.each(value.Years, function (key, value) {
            if (truckYear == value.year.replace(/~/g, '"')) {
              $.each(value.option, function (key, value) {
                if (value.mounting != undefined) {
                  quiz["mounting"] = "";
                  quiz["brackets"] = "";
                  var boolMounting = false;
                  var mountingID = value.mounting.replace(/ /g, "-");
                  $(".js__builder-mounting").each(function (index) {
                    if (mountingID == $(this).children("input").attr("id")) {
                      boolMounting = true;
                    }
                  });
                  if (boolMounting == false) {
                    $(".js__mounting-options").append('<li  class="js__builder-mounting"> <input type="radio" id="' + mountingID + '" name="mounting" value="' + value.mounting + '" >  <label class="custom-checkbox flex-align-center" for="' + mountingID + '">' + value.mounting + "</label></li>");
                  }
                } else {
                  quiz["brackets"] = "";
                  boolNoMounting = true;
                  var bracketID = value.bracket.replace(/ /g, "-");
                  var variantID = value.variantID;
                  var variantFullPrice = 0;
                  var variantPrice = 0;
                  $.each(prodBuilderProducts, function (key, values) {
                    try {
                      if (values.variantID == variantID) {
                        variantFullPrice = values.price;
                        var variantPrice = variantFullPrice / 100;
                        variantPrice = formatter.format(variantPrice);
                        $(".js__brackets-options").append('<li  class="js__builder-bracket" data-vid="' + variantID + '" data-price="' + variantPrice + '" full-data-price="' + variantFullPrice + '"> <input type="radio" id="' + bracketID + '" name="bracket" value="' + value.bracket + '" >  <label class="custom-checkbox flex-align-center" for="' + bracketID + '">' + value.bracket + "</label></li>");
                      }
                    } catch {}
                  });

                  // console.log($(".js__brackets-options").html());
                }
              });
            }
          });
        }
      });
      try {
        if (localStorage.getItem("builderData") != null) {
          if (truckYear != quizStoreData["years"]) {
            localStorage.setItem("builderData", JSON.stringify(quiz));
          } else {
            if (boolNoMounting == true) {
              $(".js__builder-bracket").each(function (index) {
                if ($(this).children("input").val() == quizStoreData["brackets"]) {
                  console.log("if22");
                  $(this).children("input").attr("checked", "checked");
                  $(this).click();
                }
              });
            } else {
              $(".js__builder-mounting").each(function (index) {
                if ($(this).children("input").val() == quizStoreData["mounting"]) {
                  console.log("if22");
                  $(this).children("input").attr("checked", "checked");
                  $(this).click();
                }
              });
            }
          }
        } else {
          localStorage.setItem("builderData", JSON.stringify(quiz));
        }
      } catch {}
    }
  });
  /*Brackets click*/
  $(document).on("click", ".js__builder-mounting", function () {
    if ($(this).children("input:checked").val() != quiz["mounting"]) {
      var truckMounting = $(this).children("input").val();
      quiz["mounting"] = truckMounting;
      $(".js__builder-total-section").hide();
      $(".js__brackets-options").empty();
      var MountingImg = "";
      if (truckMounting.indexOf("with track rail") > -1) {
        MountingImg = $(".js__withrail-img").attr("src");
      }
      if (truckMounting.indexOf("without track rail") > -1) {
        MountingImg = $(".js__withoutrail-img").attr("src");
      }
      $(".js__mounting-image").attr("src", MountingImg);
      $(".js__bracket-image").attr("src", MountingImg);
      quiz["brackets"] = "";
      console.log("truckMounting" + truckMounting);
      console.log("truck" + quiz["truck"]);
      console.log("years" + quiz["years"]);
      $.each(quizProdLib, function (key, value) {
        if (quiz["truck"] == value.type) {
          $.each(value.Years, function (key, value) {
            if (quiz["years"] == value.year.replace(/~/g, '"')) {
              $.each(value.option, function (key, value) {
                if (value.mounting != undefined) {
                  if (value.mounting == truckMounting) {
                    var bracketID = value.bracket.replace(/ /g, "-");
                    var variantID = value.variantID;
                    var variantFullPrice = 0;
                    var variantPrice = 0;
                    console.log("variantID" + variantID);
                    console.log("prodBuilderProducts" + prodBuilderProducts);
                    $.each(prodBuilderProducts, function (key, values) {
                      try {
                        console.log("values.variantID" + values.price);
                        console.log("values.variantID" + values.variantID);
                        if (values.variantID == variantID) {
                          console.log("if");
                          variantFullPrice = values.price;
                          var variantPrice = variantFullPrice / 100;
                          variantPrice = formatter.format(variantPrice);
                          $(".js__brackets-options").append('<li  class="js__builder-bracket" data-vid="' + variantID + '" data-price="' + variantPrice + '"  full-data-price="' + variantFullPrice + '"> <input type="radio" id="' + bracketID + '" name="bracket" value="' + value.bracket + '" >  <label class="custom-checkbox flex-align-center" for="' + bracketID + '">' + value.bracket + "</label></li>");
                        }
                      } catch {}
                    });

                    // var variantPrice = value.price;
                    //var variantFullPrice = value.fullPrice;
                  }
                }
              });
            }
          });
        }
      });
      try {
        if (localStorage.getItem("builderData") != null) {
          if (truckMounting != quizStoreData["mounting"]) {
            localStorage.setItem("builderData", JSON.stringify(quiz));
          }
        } else {
          localStorage.setItem("builderData", JSON.stringify(quiz));
        }
      } catch {}
      $(".js__builder-bracket").each(function (index) {
        if ($(this).children("input").val() == quizStoreData["brackets"]) {
          console.log("if22");
          $(this).children("input").attr("checked", "checked");
          $(this).click();
        }
      });
    }
  });
  /*Brackets click*/
  $(document).on("click", ".js__builder-bracket", function () {
    if ($(this).children("input:checked").val() != quiz["brackets"]) {
      var truckBracket = $(this).children("input").val();
      quiz["brackets"] = truckBracket;
      var bracketImg = "";
      if (truckBracket.indexOf("5inch") > -1) {
        bracketImg = $(".js__5inch-img").attr("src");
      }
      if (truckBracket.indexOf("8inch") > -1) {
        bracketImg = $(".js__8inch-img").attr("src");
      }
      $(".addonsImages").remove();
      $(".cart-quantity-outer").hide();
      $(".js__quiz-addons").find("input").attr("checked", false);
      var price = $(this).attr("data-price");
      $(".js__summary-truck-price").html(price);
      $(".js__summary-bracket").html(truckBracket);
      $(".js__builder-total-section").show();
      $(".js__builder-total").html(price);
      $(".js__bracket-image").attr("src", bracketImg);
      //  localStorage.setItem("builderData", JSON.stringify(quiz));

      if (localStorage.getItem("builderData") != null) {
        if (truckBracket != quizStoreData["brackets"]) {
          localStorage.setItem("builderData", JSON.stringify(quiz));
        } else {
          /* $(".js__builder-mounting").each(function (index) {
                           if($(this).children("input").val()==quizStoreData["mounting"])
                           {
                           console.log("if22");
                           $(this).children("input").attr("checked","checked")
                           $(this).click();
                           }
                         })*/
          if (quizStoreData["accessories"] != null) {
            var accessoriesData = quizStoreData["accessories"].split(",");
            for (var k = 0; k < accessoriesData.length; k++) {
              var accessoriesID = accessoriesData[k].split("~")[0];
              var accessoriesQuantity = accessoriesData[k].split("~")[1];
              $("#" + accessoriesID).val(accessoriesQuantity);
              $("#accessories" + accessoriesID).parent("li").children("label").click();
            }
          }
          if (quizStoreData["hardware"] != null) {
            console.log("hardware if");
            var hardwareData = quizStoreData["hardware"].split(",");
            console.log("hardware data" + hardwareData);
            for (var k = 0; k < hardwareData.length; k++) {
              var hardwareID = hardwareData[k];
              console.log("hardware id" + hardwareID);
              $("#hardware" + hardwareID).parent("li").children("label").click();
            }
          }
        }
      } else {
        localStorage.setItem("builderData", JSON.stringify(quiz));
      }
    }
  });
  //quiz["type"] = quizSection;
  var currentStep = 0;
  $(".js__builder-previous").click(function (e) {
    console.log("currentStep" + currentStep);
    $(".builder-section").hide();
    if (currentStep == 0) {
      $(".js__builder-section-truck-type-option").show();
    } else {
      if (boolNoMounting == true && steps[currentStep] == "brackets") {
        currentStep = 1;
        $(".js__builder-section-" + steps[currentStep]).show();
      } else {
        currentStep--;
        $(".js__builder-section-" + steps[currentStep]).show();
        /*  if (currentStep == 0) {
              $(".js__builder-previous").addClass("disabled");
          }*/
      }
    }
    $("html,body").animate({
      scrollTop: $(".builder").offset().top - 200
    }, 500);
  });
  $(".js__builder-previous-contact").click(function (e) {
    currentStep = 1;
    $(".js__builder-section-contact").hide();
    $(".js__builder-section-" + steps[currentStep]).show();
  });
  $(".js__builder-next").click(function (e) {
    console.log("current" + quiz[steps[currentStep]]);
    if (quiz[steps[currentStep]] != undefined && quiz[steps[currentStep]] != "") {
      if (quiz[steps[currentStep]] == "Other") {
        $(".builder-section").hide();
        $(".js__builder-section-contact").show();
      } else {
        $(".js__builder-previous").removeClass("disabled");
        console.log($(".js__brackets-options").html());
        if (boolNoMounting == true && steps[currentStep] == "years") {
          currentStep = 3;
          $(".builder-section").hide();
          $(".js__builder-section-" + steps[currentStep]).show();
        } else {
          currentStep++;
          $(".builder-section").hide();
          $(".js__builder-section-" + steps[currentStep]).show();
        }
      }
    } else {
      if (steps[currentStep] == "addons") {
        currentStep++;
        fullSummary();
        $(".builder-section").hide();
        $(".js__builder-section-" + steps[currentStep]).show();
      }
    }
    if (steps[currentStep] == "addons") {
      console.log("if1");
      $(".js__molle-panel").addClass("disabled");
      $(".js__builder-bracket").each(function (index) {
        console.log("each");
        if ($(this).children("input").is(":checked")) {
          console.log("if2");
          var bracketValue = $(this).children("input").val();
          console.log("dffdf" + bracketValue);
          if (bracketValue.indexOf("5inch") > -1) {
            console.log("if3");
            $(".js__molle-panel-5inch").removeClass("disabled");
          } else {
            console.log("else");
            $(".js__molle-panel-8inch").removeClass("disabled");
            $(".js__molle-panel-5inch").removeClass("disabled");
          }
        }
      });
    }
    $("html,body").animate({
      scrollTop: $(".builder").offset().top - 200
    }, 500);
  });
  function fullSummary() {
    var total = 0;
    $(".js__summary-addons").empty();
    $(".js__summary-addons-section").hide();
    $(".js__summary-mounting-section").hide();
    $(".js__builder-mounting").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        $(".js__summary-mounting-section").show();
        $(".js__summary-mounting").html($(this).children("input").val());
      }
    });
    $(".js__builder-bracket").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        total = parseFloat($(this).attr("full-data-price"));
      }
    });
    $(".js__quiz-accessories li").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        $(".js__summary-addons-section").show();
        var quantity = $(this).children(".cart-quantity-outer").children(".quantity-selector").val();
        var accessoriesPrice = parseFloat($(this).attr("data-price"));
        accessoriesPrice = accessoriesPrice * quantity;
        total += accessoriesPrice;
        var formatAccessoriesPrice = accessoriesPrice / 100;
        accessoriesPrice = formatter.format(formatAccessoriesPrice);
        var name = $(this).children("label").children(".content").children("p").html() + " x " + quantity;
        var price = $(this).children("label").children(".content").children("span").html();
        $(".js__summary-addons").append('<li class="flex-space-between"><p>' + name + "</p><p>" + accessoriesPrice + "</p></li>");
      }
    });
    $(".js__quiz-hardware li").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        $(".js__summary-addons-section").show();
        total += parseFloat($(this).attr("data-price"));
        var name = $(this).children("label").children(".content").children("p").html();
        var price = $(this).children("label").children(".content").children("span").html();
        $(".js__summary-addons").append('<li class="flex-space-between"><p>' + name + "</p><p>" + price + "</p></li>");
      }
    });
    var totalAmount = total / 100;
    $(".js__summary-price").html(formatter.format(totalAmount));

    /*Local storage for Acc and hardware*/
    setTimeout(function () {
      quiz["accessories"] = undefined;
      $(".js__quiz-accessories li").each(function (index) {
        if ($(this).children("input").is(":checked")) {
          if (quiz["accessories"] == undefined) {
            quiz["accessories"] = $(this).attr("data-variant") + "~" + $(this).find(".quantity-selector").val();
          } else {
            quiz["accessories"] = quiz["accessories"] + "," + $(this).attr("data-variant") + "~" + $(this).find(".quantity-selector").val();
          }
        }
      });
      quiz["hardware"] = undefined;
      $(".js__quiz-hardware li").each(function (index) {
        if ($(this).children("input").is(":checked")) {
          if (quiz["hardware"] == undefined) {
            quiz["hardware"] = $(this).attr("data-variant");
          } else {
            quiz["hardware"] = quiz["hardware"] + "," + $(this).attr("data-variant");
          }
        }
      });
      localStorage.setItem("builderData", JSON.stringify(quiz));
    }, 200);
  }

  /*Checkout buutton click*/
  $(".js__quiz-checkout").click(function (e) {
    /* For the main item */
    let items = [];
    $(".js__builder-bracket").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        var vid = $(this).attr("data-vid");
        items.push({
          id: vid,
          quantity: 1
        });
      }
    });
    $(".js__quiz-accessories li").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        var vid = $(this).attr("data-variant");
        var qty = parseInt($(this).find(".quantity-selector").val());
        items.push({
          id: vid,
          quantity: qty
        });
      }
    });
    $(".js__quiz-hardware li").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        var vid = $(this).attr("data-variant");
        items.push({
          id: vid,
          quantity: 1
        });
      }
    });
    CartJS.addItems(items, {
      success: function (response, textStatus, jqXHR) {
        localStorage.setItem("builderData", null);
        window.location = "/cart";
      },
      // Define an error callback to display an error message.
      error: function (jqXHR, textStatus, errorThrown) {
        //showCartErrorMessage();getItem
      }
    });
  });
  var footerTotal = 0;
  $(document).on("click", ".js__quiz-addons label", function () {
    var fiveInchImage = $(this).parent("li").attr("data-image-5inch");
    var eightInchImage = $(this).parent("li").attr("data-image-8inch");
    var variant = $(this).parent("li").attr("data-variant");
    if ($(this).parent("li").parent("ul").hasClass("js__quiz-accessories")) {
      //$(".js__molle-panel-8inch").removeClass("disabled");
      //$(".js__molle-panel-5inch").removeClass("disabled");
      if ($(this).parent("li").hasClass("js__molle-panel-8inch")) {
        if ($(".js__molle-panel-5inch").children("input").is(":checked")) {
          $(".js__molle-panel-5inch").children("label").click();
        }
      }
      if ($(this).parent("li").hasClass("js__molle-panel-5inch")) {
        if ($(".js__molle-panel-8inch").children("input").is(":checked")) {
          $(".js__molle-panel-8inch").children("label").click();
        }
      }
      /*Addons images selection*/
      if ($(this).parent("li").children("input").is(":checked")) {
        $("#addImage" + variant).remove();
        $(this).parent("li").children(".cart-quantity-outer").hide();
      } else {
        if (truckRetractableType == "No") {
          if (quiz["brackets"].indexOf("5inch") > -1) {
            if (fiveInchImage != "") {
              $(".js__addons-images").append("<img class='addonsImages' id='addImage" + variant + "' src='" + fiveInchImage + "'>");
            }
          }
          if (quiz["brackets"].indexOf("8inch") > -1) {
            if (eightInchImage != "") {
              $(".js__addons-images").append("<img class='addonsImages' id='addImage" + variant + "' src='" + eightInchImage + "'>");
            }
          }
        }
        $(this).parent("li").children(".cart-quantity-outer").show();
        // $(this).parent("li").children(".cart-quantity-outer").children(".quantity-selector").val("1");
      }
    }
    console.log("footerTotal" + footerTotal);
    var fullPrice = $(this).parent("li").attr("data-price");
    if (footerTotal == 0) {
      if (truckRetractableType == "No") {
        $(".js__builder-bracket").each(function (index) {
          if ($(this).children("input").is(":checked")) {
            footerTotal = parseFloat($(this).attr("full-data-price"));
          }
        });
      } else {
        footerTotal = parseFloat(retractableCoverVariantPrice);
      }
    }
    console.log("footerTotal2" + footerTotal);
    if ($(this).parent("li").children("input").is(":checked")) {
      if ($(this).parent("li").parent("ul").hasClass("js__quiz-accessories")) {
        var quantity = parseInt($(this).parent("li").children(".cart-quantity-outer").children(".quantity-selector").val());
        footerTotal = footerTotal - parseFloat(fullPrice * quantity);
      } else {
        footerTotal = footerTotal - parseFloat(fullPrice);
      }
    } else {
      footerTotal += parseFloat(fullPrice);
    }
    console.log("footerTotal" + footerTotal);
    var totalAmount = footerTotal / 100;
    if (truckRetractableType == "No") {
      $(".js__builder-total").html(formatter.format(totalAmount));
    } else {
      $(".js__builder-retractable-covers-total").html(formatter.format(totalAmount));
    }
  });
  $(document).on("click", ".js__builder-quantity", function () {
    var quantity = parseInt($(this).parent(".cart-quantity-outer").children(".quantity-selector").val());
    if (quantity > 0) {
      if ($(this).hasClass("minus-qty")) {
        quantity--;
        if ($(this).parent(".cart-quantity-outer").parent("li").hasClass("js__molle-panel-8inch") || $(this).parent(".cart-quantity-outer").parent("li").hasClass("js__molle-panel-5inch")) {
          var variantID = $(this).parent(".cart-quantity-outer").parent("li").attr("data-variant");
          if (quantity == 1) {
            if ($(this).parent(".cart-quantity-outer").parent("li").hasClass("js__molle-panel-8inch")) {
              var eightInchImage = $(this).parent(".cart-quantity-outer").parent("li").attr("data-image-8inch");
              if (eightInchImage != "") {
                $("#addImage" + variantID).attr("src", eightInchImage);
              }
            } else {
              var fiveInchImage = $(this).parent(".cart-quantity-outer").parent("li").attr("data-image-5inch");
              if (fiveInchImage != "") {
                $("#addImage" + variantID).attr("src", fiveInchImage);
              }
            }
          }
        }
      } else {
        if ($(this).parent(".cart-quantity-outer").parent("li").hasClass("js__molle-panel-8inch") || $(this).parent(".cart-quantity-outer").parent("li").hasClass("js__molle-panel-5inch")) {
          var variantID = $(this).parent(".cart-quantity-outer").parent("li").attr("data-variant");
          if (quantity == 1) {
            quantity++;
            if ($(this).parent(".cart-quantity-outer").parent("li").hasClass("js__molle-panel-8inch")) {
              var eightInchDualImage = $(this).parent(".cart-quantity-outer").parent("li").attr("data-image-8inchdual");
              if (eightInchDualImage != "") {
                $("#addImage" + variantID).attr("src", eightInchDualImage);
              }
            } else {
              var fiveInchDualImage = $(this).parent(".cart-quantity-outer").parent("li").attr("data-image-5inchdual");
              if (fiveInchDualImage != "") {
                $("#addImage" + variantID).attr("src", fiveInchDualImage);
              }
            }
          }
        } else {
          quantity++;
        }
      }
    }
    $(this).parent(".cart-quantity-outer").children(".quantity-selector").val(quantity);
    if (quantity == 0) {
      $(this).parent(".cart-quantity-outer").parent("li").children("label").click();
    }
    console.log("footerTotal" + footerTotal);
    var fullPrice = $(this).parent(".cart-quantity-outer").parent("li").attr("data-price");
    if (footerTotal == 0) {
      if (truckRetractableType == "No") {
        $(".js__builder-bracket").each(function (index) {
          if ($(this).children("input").is(":checked")) {
            footerTotal = parseFloat($(this).attr("full-data-price"));
          }
        });
      } else {
        footerTotal = parseFloat(retractableCoverVariantPrice);
      }
    }
    console.log("footerTotal" + footerTotal);
    if ($(this).hasClass("minus-qty")) {
      footerTotal = footerTotal - parseFloat(fullPrice);
    } else {
      footerTotal += parseFloat(fullPrice);
    }
    console.log("footerTotal" + footerTotal);
    var totalAmount = footerTotal / 100;
    if (truckRetractableType == "No") {
      $(".js__builder-total").html(formatter.format(totalAmount));
    } else {
      $(".js__builder-retractable-covers-total").html(formatter.format(totalAmount));
    }
  });

  /* Retractable covers step array*/
  var stepsRetractableCovers = ["truck", "years", "height-and-length", "addons", "summary"];

  /* Page load append trucks for Retractable covers*/
  try {
    $.each(builderRetractableProdLib, function (key, value) {
      try {
        var truckID = value.type.replace(/ /g, "-");
        $(".js__quiz-retractable-covers-truck").append('<li class="js__builder-retractable-covers-truck-type"><input type="radio" id="retractable-covers-' + truckID + '" name="truck-retractable-group" value="' + value.type + '" ><label for="retractable-covers-' + truckID + '" class="flex-align-center"><div class="relative image-section"><img src="' + value.image + '"  alt=""></div><p>' + value.type + "</p></label></li>");
      } catch {}
    });
  } catch {}
  quizRetractable = {};
  /*Truck type click*/
  $(document).on("click", ".js__builder-retractable-covers-truck-type", function () {
    console.log("click");
    console.log($(this).children("input").val());
    if ($(this).children("input:checked").val() == "Custom") {
      window.location.href = "/collections/billie-bars/products/billiebars-custom-sets";
    } else {
      if ($(this).children("input:checked").val() != quizRetractable["truck"]) {
        var truckType = $(this).children("input").val();
        console.log("else");
        console.log(truckType);
        $(".js__builder-total-section").hide();
        $(".js__year-retractable-covers-options").empty();
        $(".js__height-options").empty();
        $(".js__BD-length-options").empty();
        quizRetractable = null;
        quizRetractable = {};
        quizRetractable["truck"] = truckType;
        $(".js__selected-retractable-covers-truck").html("For " + truckType);
        $(".js__retractable-covers-summary-truck").html(truckType);
        $.each(builderRetractableProdLib, function (key, value) {
          try {
            if (truckType == value.type) {
              $.each(value.Years, function (key, value) {
                //alert(value.year);
                var yearID = value.year.replace(/ /g, "-");
                var yearValue = value.year.replace(/"/g, "~");
                yearID = yearID.replace(/"/g, "-");
                $(".js__year-retractable-covers-options").append('<li  class="js__builder-retractable-covers-year"> <input type="radio" id="retractable-covers-' + yearID + '" name="retractable-covers-year" value="' + yearValue + '" >  <label class="custom-checkbox flex-align-center" for="retractable-covers-' + yearID + '">' + value.year + "</label></li>");
              });
              $(".js__year-retractable-covers-options").append('<li  class="js__builder-retractable-covers-year"> <input type="radio" id="builder-other-retractable-covers-year" name="retractable-covers-year" value="Other" >  <label class="custom-checkbox flex-align-center" for="builder-other-retractable-covers-year">Other</label></li>');
            }
          } catch {}
        });
        //localStorage.setItem("builderData", quiz);
        // localStorage.setItem("builderData", JSON.stringify(quiz));
        //quizRetractableCoversStoreData
        //builderRetractableCoversData
        // save to localStorage
        try {
          if (localStorage.getItem("builderRetractableCoversData") != null) {
            if (truckType != quizRetractableCoversStoreData["truck"]) {
              localStorage.setItem("builderRetractableCoversData", JSON.stringify(quizRetractable));
            }
          } else {
            localStorage.setItem("builderRetractableCoversData", JSON.stringify(quizRetractable));
          }
          $(".js__builder-retractable-covers-year").each(function (index) {
            if ($(this).children("input").val().replace(/~/g, '"') == quizRetractableCoversStoreData["years"]) {
              console.log("if22");
              $(this).children("input").attr("checked", "checked");
              $(this).click();
            }
          });
        } catch {}
      }
    }
  });
  /*Truck Year click*/
  $(document).on("click", ".js__builder-retractable-covers-year", function () {
    if ($(this).children("input:checked").val() != quizRetractable["years"]) {
      var truckYear = $(this).children("input").val().replace(/~/g, '"');
      $(".js__retractable-covers-height-options").empty();
      $(".js__retractable-covers-bed-length-options").empty();
      $(".js__builder-retractable-covers-total-section").hide();
      $(".js__retractable-covers-height-options-section").hide();
      $(".js__retractable-covers-bed-length-options-section").hide();
      quizRetractable["years"] = truckYear;
      $(".js__retractable-covers-height-length-image").attr("src", heightDefaultImage);
      $.each(builderRetractableProdLib, function (key, value) {
        try {
          if (quizRetractable["truck"] == value.type) {
            $.each(value.Years, function (key, value) {
              if (truckYear == value.year.replace(/~/g, '"')) {
                $.each(value.option, function (key, value) {
                  quizRetractable["height"] = "";
                  quizRetractable["bed-length"] = "";
                  if (value.height != "") {
                    $(".js__retractable-covers-height-options-section").show();
                    var heightID = value.height.replace(/[^a-zA-Z0-9 ]/g, "-");
                    heightID = heightID.replace(/ /g, "-");
                    heightID = heightID.replace(/--/g, "-");
                    heightID = heightID.replace(/---/g, "-");
                    $(".js__retractable-covers-height-options").append("<li  class='js__builder-retractable-covers-height js__builder-retractable-covers-variant-options' > <input type='radio' id='" + heightID + "' name='retractable-covers-height' value='" + value.height + "' >  <label class='custom-checkbox flex-align-center' for='" + heightID + "'>" + value.height + "</label></li>");
                  }
                  if (value.bedLength != "") {
                    $(".js__retractable-covers-bed-length-options-section").show();
                    var bedLengthID = value.bedLength.replace(/[^a-zA-Z0-9 ]/g, "-");
                    bedLengthID = bedLengthID.replace(/ /g, "-");
                    bedLengthID = bedLengthID.replace(/--/g, "-");
                    bedLengthID = bedLengthID.replace(/---/g, "-");
                    $(".js__retractable-covers-bed-length-options").append("<li  class='js__builder-retractable-covers-bed-length js__builder-retractable-covers-variant-options' > <input type='radio' id='" + bedLengthID + "' name='retractable-covers-bed-length' value='" + value.bedLength + "' >  <label class='custom-checkbox flex-align-center' for='" + bedLengthID + "'>" + value.bedLength + "</label></li>");
                  }

                  // console.log($(".js__brackets-options").html());
                });
                var uniqueLi = {};
                $(".js__retractable-covers-height-options li").each(function () {
                  var thisVal = $(this).text();
                  if (!(thisVal in uniqueLi)) {
                    uniqueLi[thisVal] = "";
                  } else {
                    $(this).remove();
                  }
                });
                uniqueLi = {};
                $(".js__retractable-covers-bed-length-options li").each(function () {
                  var thisVal = $(this).text();
                  if (!(thisVal in uniqueLi)) {
                    uniqueLi[thisVal] = "";
                  } else {
                    $(this).remove();
                  }
                });
              }
            });
          }
        } catch {}
      });
      try {
        //quizRetractableCoversStoreData
        //builderRetractableCoversData
        if (localStorage.getItem("builderRetractableCoversData") != null) {
          if (truckYear != quizRetractableCoversStoreData["years"]) {
            localStorage.setItem("builderRetractableCoversData", JSON.stringify(quizRetractable));
          } else {
            $(".js__retractable-cover-brand").val(quizRetractableCoversStoreData["cover-brand"]);
            $(".js__builder-retractable-covers-height").each(function (index) {
              if ($(this).children("input").val() == quizRetractableCoversStoreData["height"]) {
                console.log("if22");
                $(this).children("input").attr("checked", "checked");
                $(this).click();
              }
            });
            $(".js__builder-retractable-covers-bed-length").each(function (index) {
              if ($(this).children("input").val() == quizRetractableCoversStoreData["bed-length"]) {
                console.log("if22");
                $(this).children("input").attr("checked", "checked");
                $(this).click();
              }
            });
          }
        } else {
          localStorage.setItem("builderRetractableCoversData", JSON.stringify(quizRetractable));
        }
      } catch {}
    }
  });
  // } catch {}

  /*Truck options click*/
  $(document).on("click", ".js__builder-retractable-covers-variant-options", function () {
    var height = "";
    var bedLength = "";
    $(".js__builder-retractable-covers-height").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        height = $(this).children("input").val();
        quizRetractable["height-and-length"] = height;
      }
    });
    $(".js__builder-retractable-covers-bed-length").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        bedLength = $(this).children("input").val();
        quizRetractable["height-and-length"] = bedLength;
      }
    });
    $(".js__quiz-addons").find("input").attr("checked", false);
    $(".Up-6").removeClass("disabled");
    $(".Down-11").removeClass("disabled");
    if (height != "") {
      if (height == 'LOW PROFILE 6"') {
        $(".Up-6").addClass("disabled");
        $(".Up-6").children("input").removeAttr("checked");
      } else {
        $(".Down-11").addClass("disabled");
        $(".Down-11").children("input").removeAttr("checked");
      }
    }
    quizRetractable["height"] = height;
    quizRetractable["bed-length"] = bedLength;
    getRetractableCoverVariantInfo();
    /*   if (localStorage.getItem("builderRetractableCoversData") != null) {
        if (bedLength != quizRetractableCoversStoreData["bed-length"] || height != quizRetractableCoversStoreData["height"]) {
            localStorage.setItem("builderRetractableCoversData", JSON.stringify(quizRetractable));
          } else {
              
            if (quizRetractableCoversStoreData["accessories"] != null) {
                var accessoriesData = quizRetractableCoversStoreData["accessories"].split(",");
                for (var k = 0; k < accessoriesData.length; k++) {
                    var accessoriesID = accessoriesData[k].split("~")[0];
                    var accessoriesQuantity = accessoriesData[k].split("~")[1];
                    $("#" + accessoriesID).val(accessoriesQuantity);
                    $("#accessories" + accessoriesID)
                        .parent("li")
                        .children("label")
                        .click();
                }
            }
            if (quizRetractableCoversStoreData["hardware"] != null) {
                console.log("hardware if");
                  var hardwareData = quizRetractableCoversStoreData["hardware"].split(",");
                console.log("hardware data" + hardwareData);
                for (var k = 0; k < hardwareData.length; k++) {
                    var hardwareID = hardwareData[k];
                      console.log("hardware id" + hardwareID);
                    $("#hardware" + hardwareID)
                        .parent("li")
                        .children("label")
                        .click();
                }
            }
        }
    } else {
          localStorage.setItem("builderRetractableCoversData", JSON.stringify(quizRetractable));
      }
    */
  });
  var heightDefaultImage = $(".js__retractable-covers-height-length-image").attr("src");
  var retractableCoverVariantPrice = 0;
  /*For get variant id using truck year height and bedlength*/
  function getRetractableCoverVariantInfo() {
    var year = quizRetractable["years"];
    var truck = quizRetractable["truck"];
    var height = "";
    var bedLength = "";
    $(".js__builder-retractable-covers-height").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        height = $(this).children("input").val();
        quizRetractable["height-and-length"] = height;
      }
    });
    $(".js__builder-retractable-covers-bed-length").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        bedLength = $(this).children("input").val();
        quizRetractable["height-and-length"] = bedLength;
      }
    });
    console.log("year" + year);
    console.log("truck" + truck);
    console.log("height" + height);
    console.log("bedLength" + bedLength);
    if (height != "") {
      $.each(builderHeightImages, function (key, value) {
        if (height.toLowerCase() == value.name.toLowerCase()) {
          $(".js__retactable-height-image").attr("src", value.image);
          $(".js__retractable-covers-height-length-image").attr("src", value.image);
        }
      });
    }
    if (bedLength != undefined && height != undefined) {
      console.log("if1");
      $.each(builderRetractableProdLib, function (key, value) {
        try {
          if (truck == value.type) {
            console.log("if2");
            $.each(value.Years, function (key, value) {
              if (year == value.year.replace(/~/g, '"')) {
                console.log("if3");
                $.each(value.option, function (key, value) {
                  if ($(".js__retractable-covers-bed-length-options-section").css("display") != "none") {
                    if (height == value.height && bedLength == value.bedLength) {
                      console.log("if4");
                      console.log("value.variantID" + value.variantID);
                      console.log("value.price" + value.price);
                      retractableCoversVariantID = value.variantID;
                      var price = value.price;
                      retractableCoverVariantPrice = value.fullPrice;
                      $(".js__summary-retractable-covers-truck-price").html(price);
                      $(".js__summary-retractable-covers-price").html(price);
                      $(".js__builder-retractable-covers-total-section").show();
                      $(".js__builder-retractable-covers-total").html(price);
                    }
                  } else {
                    if (height == value.height) {
                      console.log("if4");
                      console.log("value.variantID" + value.variantID);
                      console.log("value.price" + value.price);
                      retractableCoversVariantID = value.variantID;
                      var price = value.price;
                      retractableCoverVariantPrice = value.fullPrice;
                      $(".js__summary-retractable-covers-truck-price").html(price);
                      $(".js__summary-retractable-covers-price").html(price);
                      $(".js__builder-retractable-covers-total-section").show();
                      $(".js__builder-retractable-covers-total").html(price);
                    }
                  }
                });
              }
            });
          }
        } catch {}
      });

      //  js__height-image
    }
  }
  var truckRetractableType = "No";
  /*Select truck type*/
  $(".js__builder-retractable-covers-option").click(function (e) {
    var truckOption = $(this).attr("data-attr");
    $(".builder-section").removeClass("active");
    $(".builder-section").hide();
    if (truckOption == "yes") {
      $(".js__builder-footer-section").hide();
      $(".js__builder-retractable-footer-section").show();
      truckRetractableType = "Yes";
      $(".js__builder-section-retractable-covers-truck").addClass("active");
      $(".js__builder-section-retractable-covers-truck").show();
      $(".js__quiz-accessories .Retractable").show();
      $(".js__quiz-accessories .Non-Retractable").hide();
      $(".js__quiz-accessories .Non-Retractable").children("input").removeAttr("checked");
    } else {
      $(".js__builder-footer-section").show();
      $(".js__builder-retractable-footer-section").hide();
      truckRetractableType = "No";
      $(".js__builder-section-truck").addClass("active");
      $(".js__builder-section-truck").show();
      $(".js__quiz-accessories .Retractable").hide();
      $(".js__quiz-accessories .Retractable").children("input").removeAttr("checked");
      $(".js__quiz-accessories .Non-Retractable").show();
    }
  });
  var currentRetractableCoversStep = 0;
  $(".js__builder-retractable-covers-previous").click(function (e) {
    $(".builder-section").hide();

    /* if (currentRetractableCoversStep == 0) {
         $(".js__builder-retractable-covers-previous").addClass("disabled");
     }*/

    if (currentRetractableCoversStep == 0) {
      $(".js__builder-section-truck-type-option").show();
    } else {
      currentRetractableCoversStep--;
      $(".js__builder-section-retractable-covers-" + stepsRetractableCovers[currentRetractableCoversStep]).show();
    }
    $("html,body").animate({
      scrollTop: $(".builder").offset().top - 200
    }, 500);
  });
  $(".js__builder-retractable-covers-next").click(function (e) {
    console.log("current" + quizRetractable[stepsRetractableCovers[currentRetractableCoversStep]]);
    if (quizRetractable[stepsRetractableCovers[currentRetractableCoversStep]] != undefined && quizRetractable[stepsRetractableCovers[currentRetractableCoversStep]] != "") {
      console.log("ifff");
      if (quizRetractable[stepsRetractableCovers[currentRetractableCoversStep]] == "Other") {
        $(".builder-section").hide();
        $(".js__builder-section-contact").show();
      } else {
        console.log("elseee");
        $(".js__builder-retractable-covers-previous").removeClass("disabled");
        if (stepsRetractableCovers[currentRetractableCoversStep] == "height-and-length") {
          console.log("ifff2");
          footerTotal = 0;
          var height = "";
          var bedLength = "";
          $(".js__builder-retractable-covers-height").each(function (index) {
            if ($(this).children("input").is(":checked")) {
              height = $(this).children("input").val();
            }
          });
          $(".js__builder-retractable-covers-bed-length").each(function (index) {
            if ($(this).children("input").is(":checked")) {
              bedLength = $(this).children("input").val();
            }
          });
          if ($(".js__retractable-cover-brand").val() != "") {
            $("#error-cover-brand").hide();
            quizRetractable["cover-brand"] = $(".js__retractable-cover-brand").val();
            if (localStorage.getItem("builderRetractableCoversData") != null) {
              if (bedLength != quizRetractableCoversStoreData["bed-length"] || height != quizRetractableCoversStoreData["height"]) {
                localStorage.setItem("builderRetractableCoversData", JSON.stringify(quizRetractable));
              } else {
                if (quizRetractableCoversStoreData["accessories"] != null) {
                  var accessoriesData = quizRetractableCoversStoreData["accessories"].split(",");
                  for (var k = 0; k < accessoriesData.length; k++) {
                    var accessoriesID = accessoriesData[k].split("~")[0];
                    var accessoriesQuantity = accessoriesData[k].split("~")[1];
                    $("#" + accessoriesID).val(accessoriesQuantity);
                    $("#accessories" + accessoriesID).parent("li").children("label").click();
                  }
                }
                if (quizRetractableCoversStoreData["hardware"] != null) {
                  console.log("hardware if");
                  var hardwareData = quizRetractableCoversStoreData["hardware"].split(",");
                  console.log("hardware data" + hardwareData);
                  for (var k = 0; k < hardwareData.length; k++) {
                    var hardwareID = hardwareData[k];
                    console.log("hardware id" + hardwareID);
                    $("#hardware" + hardwareID).parent("li").children("label").click();
                  }
                }
              }
            } else {
              localStorage.setItem("builderRetractableCoversData", JSON.stringify(quizRetractable));
            }
            localStorage.setItem("builderRetractableCoversData", JSON.stringify(quizRetractable));
            if ($(".js__retractable-covers-bed-length-options-section").css("display") != "none") {
              if (bedLength != "" && height != "") {
                currentRetractableCoversStep++;
                console.log("current" + stepsRetractableCovers[currentRetractableCoversStep]);
                $(".builder-section").hide();
                $(".js__builder-section-retractable-covers-" + stepsRetractableCovers[currentRetractableCoversStep]).show();
              }
            } else {
              if (height != "") {
                currentRetractableCoversStep++;
                console.log("current" + stepsRetractableCovers[currentRetractableCoversStep]);
                $(".builder-section").hide();
                $(".js__builder-section-retractable-covers-" + stepsRetractableCovers[currentRetractableCoversStep]).show();
              }
            }
          } else {
            $("#error-cover-brand").show();
          }
        } else {
          currentRetractableCoversStep++;
          console.log("current" + stepsRetractableCovers[currentRetractableCoversStep]);
          $(".builder-section").hide();
          $(".js__builder-section-retractable-covers-" + stepsRetractableCovers[currentRetractableCoversStep]).show();
        }
      }
    } else {
      if (stepsRetractableCovers[currentRetractableCoversStep] == "addons") {
        fullRetractableCoversSummary();
        currentRetractableCoversStep++;
        $(".builder-section").hide();
        $(".js__builder-section-retractable-covers-" + stepsRetractableCovers[currentRetractableCoversStep]).show();
      }
    }
    $("html,body").animate({
      scrollTop: $(".builder").offset().top - 200
    }, 500);
  });
  var retractableCoversVariantID = "";
  /* Retractable Covers Summary*/
  function fullRetractableCoversSummary() {
    var height = "";
    var bedLength = "";
    $(".js__builder-retractable-covers-height").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        height = $(this).children("input").val();
      }
    });
    $(".js__builder-retractable-covers-bed-length").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        bedLength = $(this).children("input").val();
      }
    });
    $(".js__retractable-covers-summary-addons").empty();
    $(".js__retractable-covers-summary-addons-section").hide();
    $(".js__retractable-covers-summary-height").html(height);
    if ($(".js__retractable-covers-bed-length-options-section").css("display") == "none") {
      $(".js__retractable-covers-summary-length-section").hide();
    } else {
      $(".js__retractable-covers-summary-length").html(bedLength);
      $(".js__retractable-covers-summary-length-section").show();
    }
    $(".js__retractable-covers-summary-brandcover").html($(".js__retractable-cover-brand").val());
    var total = parseFloat(retractableCoverVariantPrice);
    console.log("total" + total);
    var formatRetractableCoverVariantPrice = parseFloat(retractableCoverVariantPrice) / 100;
    formatRetractableCoverVariantPrice = formatter.format(formatRetractableCoverVariantPrice);
    $(".js__retractable-covers-summary-truck-price").html(formatRetractableCoverVariantPrice);
    $(".js__quiz-accessories li").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        $(".js__retractable-covers-summary-addons-section").show();
        var quantity = $(this).children(".cart-quantity-outer").children(".quantity-selector").val();
        var accessoriesPrice = parseFloat($(this).attr("data-price"));
        accessoriesPrice = accessoriesPrice * quantity;
        total += accessoriesPrice;
        var formatAccessoriesPrice = accessoriesPrice / 100;
        accessoriesPrice = formatter.format(formatAccessoriesPrice);
        var name = $(this).children("label").children(".content").children("p").html() + " x " + quantity;
        var price = $(this).children("label").children(".content").children("span").html();
        $(".js__retractable-covers-summary-addons").append('<li class="flex-space-between"><p>' + name + "</p><p>" + accessoriesPrice + "</p></li>");
      }
    });
    $(".js__quiz-hardware li").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        $(".js__retractable-covers-summary-addons-section").show();
        total += parseFloat($(this).attr("data-price"));
        var name = $(this).children("label").children(".content").children("p").html();
        var price = $(this).children("label").children(".content").children("span").html();
        $(".js__retractable-covers-summary-addons").append('<li class="flex-space-between"><p>' + name + "</p><p>" + price + "</p></li>");
      }
    });
    console.log("total" + total);
    var totalAmount = total / 100;
    $(".js__summary-retractable-covers-price").html(formatter.format(totalAmount));

    /*Local storage for Acc and hardware*/
    setTimeout(function () {
      quizRetractable["accessories"] = undefined;
      $(".js__quiz-accessories li").each(function (index) {
        if ($(this).children("input").is(":checked")) {
          if (quizRetractable["accessories"] == undefined) {
            quizRetractable["accessories"] = $(this).attr("data-variant") + "~" + $(this).find(".quantity-selector").val();
          } else {
            quizRetractable["accessories"] = quizRetractable["accessories"] + "," + $(this).attr("data-variant") + "~" + $(this).find(".quantity-selector").val();
          }
        }
      });
      quizRetractable["hardware"] = undefined;
      $(".js__quiz-hardware li").each(function (index) {
        if ($(this).children("input").is(":checked")) {
          if (quizRetractable["hardware"] == undefined) {
            quizRetractable["hardware"] = $(this).attr("data-variant");
          } else {
            quizRetractable["hardware"] = quizRetractable["hardware"] + "," + $(this).attr("data-variant");
          }
        }
      });
      localStorage.setItem("builderRetractableCoversData", JSON.stringify(quizRetractable));
    }, 200);
  }

  /*Checkout Retractable covers button click*/
  $(".js__quiz-retractable-covers-checkout").click(function (e) {
    /* For the main item */
    let items = [];
    if ($(".js__retractable-cover-brand").val() != "") {
      items.push({
        id: retractableCoversVariantID,
        quantity: 1,
        properties: {
          'Cover Brand': $(".js__retractable-cover-brand").val()
        }
      });
    } else {
      items.push({
        id: retractableCoversVariantID,
        quantity: 1
      });
    }
    $(".js__quiz-accessories li").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        var vid = $(this).attr("data-variant");
        var qty = parseInt($(this).find(".quantity-selector").val());
        items.push({
          id: vid,
          quantity: qty
        });
      }
    });
    $(".js__quiz-hardware li").each(function (index) {
      if ($(this).children("input").is(":checked")) {
        var vid = $(this).attr("data-variant");
        items.push({
          id: vid,
          quantity: 1
        });
      }
    });
    CartJS.addItems(items, {
      success: function (response, textStatus, jqXHR) {
        localStorage.setItem("builderRetractableCoversData", null);
        window.location = "/cart";
      },
      // Define an error callback to display an error message.
      error: function (jqXHR, textStatus, errorThrown) {
        //showCartErrorMessage();getItem
      }
    });
  });
});
"use strict";

// tweaks these below variable if you want to show subtotal and discount
var showCartSubTotalDiscountSection = true;
var showEmptyCartIcon = false;
var showCartCountInTopNav = true;
var showProgressBar = true;
var showVendorOnCartPage = false;
var enablePlusQuantity = false;
var disablePlusQuantityAfterNumber = 6;
var removeMiniCartTextOrIcon = '<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g stroke="#37312F" stroke-width="2" fill="none" fill-rule="evenodd" opacity=".5"><path d="m14.243 5.757-8.486 8.486M5.757 5.757l8.486 8.486"/></g></svg>';
var plusIcon = '<svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><g stroke="#37312F" fill="none" fill-rule="evenodd"> <path d="M5 0v10M10 5H0"/></g></svg>';
var minusIcon = '<svg width="10" height="1" viewBox="0 0 10 1" xmlns="http://www.w3.org/2000/svg"><path d="M10 .5H0" stroke="#37312F" fill="none" fill-rule="evenodd"/></svg>';

// Fixed variables
var lineItemComparePrice;
var cartObject;
var cartCountEmptyValue = "0";
var boxID = "_Box ID";
//extra classes for the elements
var removeExtraClass = "btn-border-black-animate";

/* CUSTOM OFFERS */
//black friday main productID
var promoOfferQuantity = 0;
var boolPromoOffer_BlackFriday_ProductID = false;
//Replace on LIVE
var promoOffer_BlackFriday_ProductID = "6737920098374";
var promoOffer_BlackFriday_FreeBag_ProductID = "6737924587590";
// recharge 2020
var frequency = "";
var recurringchecked = false;
var frequency_unit = "";
$(document).ready(function ($) {
  reloadAjaxCartItemUsingCartAjaxObject();
  progressBar();
  quickCartTotal();
  calculateSubTotalWithDiscount();
  /*cart numeric type*/
  $(".js__cart__quantity-selector").keypress(function (event) {
    var keycode = event.keyCode || event.which;
    if (keycode == "13") {
      event.preventDefault();
      if ($(this).val() == "0") {
        $(this).val("1");
      }
      var lineCount = $(this).attr("data-cart-line-count");
      updateQuantity(lineCount);
      return false;
    }
  });
});
/*
EVENTS
1. Update quantity
2. minus quantity
3. plus quantity
4. remove item from cart
5. reload ajax cart
6. quickCartTotal
7. calculateSubTotalWithDiscount
8. cart.requestComplete
*/
//QUANTITY UPDATE
function updateQuantity(cartThis) {
  let lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  let itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  let lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  let variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  /* NOTE: you will not get Raw Inventory against the variant in API calls */
  /* PENDING, need to find a solution for this */
  /* Need to check stock levels for the variant 
  as cartJS is giving success even if the stock levels are low and not going into Error*/
  var rawStockVariantQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").attr("data-attr-raw-variant-quantity");
  /* If the new quantity is less then the stock then update the item */
  rawStockVariantQuantity = isNaN(rawStockVariantQuantity) ? "10000" : rawStockVariantQuantity;
  rawStockVariantQuantity = parseInt(rawStockVariantQuantity);
  if (newQuantity < rawStockVariantQuantity) {
    $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);
    /* Update the item */
    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function (data, textStatus, jqXHR) {
        //console.log(data);
        // //Rebind the line item price
        // reloadAjaxCartItemUsingCartAjaxObject(data);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        //console.log("Error: " + errorThrown + "!");
      },
      complete: function (jqXHR, textStatus, errorThrown) {
        //console.log(jqXHR);
        //console.log(textStatus);
        //console.log(errorThrown);
      }
    });
  } else {
    /* Show a message out of stock */
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").html("Out of stock");
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").show();
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").delay(2000).fadeOut();
  }
}
function minusQuantity(cartThis) {
  // debugger;
  let lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  let itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  let lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  let variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  newQuantity = newQuantity - 1;
  $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);

  // CUSTOM - Loop through properties to check if there is a product with PromoOffer, if yes, then set the bool to true
  let properties = loopThroughCartItems_on_VariantID(variantID);
  if (properties != null) {
    if (Object.keys(properties).length > 0) {
      $.each(properties, function (key, value) {
        if (key == "_promoOffer") {
          boolPromoOffer_BlackFriday_ProductID = true;
        }
      });
    }
  }
  if (newQuantity < 1) {
    removeItem(lineItemCount);
  } else {
    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function (data, textStatus, jqXHR) {},
      error: function (jqXHR, textStatus, errorThrown) {
        //console.log("Error: " + errorThrown + "!");
      }
    });
    /*
    if you want to update item by ID and not by line item then you can use updateItemId function
    Recommended - line item update
    CartJS.updateItemById(lineIndex, newQuantity);
    */
  }
  // CUSTOM -
  //if the promo main product exists and it's quantity is less then 2, then remove the promo free bag product
  // if promo main product quantity  = 1; then remove the free bag and update the promo main product quantity
  // if promo main product quantity  = 0; then remove the promo main product
  // update the quantity for the promo main product
  if (boolPromoOffer_BlackFriday_ProductID && newQuantity <= 1) {
    if (newQuantity == 1) {
      //console.log("BLACK FRIDAY: Quantity 1");
      //loop through the cart items to get the variant ID for the PROMO - Free bag product
      //console.log("BLACK FRIDAY: going to delete free bag ");
      let variantID = loopThroughCartItems_on_ProductID(promoOffer_BlackFriday_FreeBag_ProductID);
      removeItemById(variantID);
    }
  }
}
function plusQuantity(cartThis) {
  let lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  let itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  let lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  let variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  // Disable the PLUS quantity feature
  var proceedToUpdateQuantity = false;
  if (enablePlusQuantity) {
    if (newQuantity > disablePlusQuantityAfterNumber) {
      proceedToUpdateQuantity = true;
    }
  }
  if (proceedToUpdateQuantity == false) {
    newQuantity = newQuantity + 1;
    /* NOTE: you will not get Raw Inventory against the variant in API calls */
    /* PENDING, need to find a solution for this */
    /* Need to check stock levels for the variant 
    as cartJS is giving success even if the stock levels are low and not going into Error*/
    var rawStockVariantQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").attr("data-attr-raw-variant-quantity");
    /* If the new quantity is less then the stock then update the item */
    rawStockVariantQuantity = isNaN(rawStockVariantQuantity) ? "10000" : rawStockVariantQuantity;
    rawStockVariantQuantity = parseInt(rawStockVariantQuantity);
    if (newQuantity < rawStockVariantQuantity) {
      $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);
      /* Update the item */
      CartJS.updateItem(lineItemCount, newQuantity, {}, {
        success: function (data, textStatus, jqXHR) {
          //console.log(data);
          // //Rebind the line item price
          // reloadAjaxCartItemUsingCartAjaxObject(data);
        },
        error: function (jqXHR, textStatus, errorThrown) {
          //console.log("Error: " + errorThrown + "!");
        },
        complete: function (jqXHR, textStatus, errorThrown) {
          //console.log(jqXHR);
          //console.log(textStatus);
          //console.log(errorThrown);
        }
      });
    } else {
      /* Show a message out of stock */
      $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").html("Out of stock");
      $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").show();
      $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").delay(2000).fadeOut();
    }
  }
}
//REMOVE ITEM via lineItemCount
function removeItem(lineItemCount) {
  CartJS.removeItem(lineItemCount, {
    success: function (data, textStatus, jqXHR) {},
    error: function (jqXHR, textStatus, errorThrown) {
      //console.log('Error: ' + errorThrown + '!');
    }
  });
}
// REMOVE ITEM via variantID
//REMOVE ITEM
function removeItemById(variantID) {
  CartJS.removeItemById(variantID, {
    success: function (data, textStatus, jqXHR) {},
    error: function (jqXHR, textStatus, errorThrown) {
      //console.log('Error: ' + errorThrown + '!');
    }
  });
}
//RELOAD AJAX CART
function reloadAjaxCartItemUsingCartAjaxObject(data) {
  var lineCount = 1;
  var cartObject;

  //console.log(data);
  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
    quickCartTotal(data);
  }
  $(".js__ajax-products-bind").html("");
  $(".cart-list").html("");
  $(".js__top-cart-form-actions li").show();
  $(cartObject.items).each(function () {
    var imageURL = this.featured_image.url;
    var imageAlt = this.featured_image.alt;
    var itemPrice = this.original_price;
    var itemLinePriceTotal = this.line_price;
    var handle = this.handle;
    var itemID = this.id;
    var itemPriceAfterDiscount = this.discounted_price;
    var comparePrice = "";
    let disabled = "";
    let finalLineItemPrice = this.final_line_price;
    let cartBundleBoxID = "";
    let boolPromoOffer = false;
    let itemProperties = "";
    $(".recommended-proruct-section li").each(function (index) {
      if ($(this).attr("data-attr-variantid") == itemID) {
        $(this).hide();
      }
    });
    var boolFeaturedProduct = false;
    $(".recommended-proruct-section li").each(function (index) {
      if ($(this).css("display") != "none") {
        boolFeaturedProduct = true;
      }
    });
    if (boolFeaturedProduct == false) {
      $(".recommended-proruct-section").hide();
    } else {
      $(".recommended-proruct-section").show();
    }

    //  js__top-cart-form-actions
    /*Bundle Free Bag Product*/
    if (this.properties != null) {
      itemProperties = this.properties;
      if (Object.keys(itemProperties).length > 0) {
        $.each(itemProperties, function (key, value) {
          /* If box ID exists, then remove quantity + -  working */
          if (key == boxID) {
            cartBundleBoxID = value;
          }
          if (key == "_promoOffer") {
            boolPromoOffer = true;
          }
        });
      }
    }
    /* get compare price using cartLib object */
    if (typeof cartLib !== "undefined") {
      $.each(cartLib, function (key, value) {
        //console.log(value);
        if (value["id"] == itemID) {
          comparePrice = value["comparePrice"];
        }
      });
    }
    /* FORMATTED PRICING */
    var formattedcomparePrice = comparePrice / 100;
    formattedcomparePrice = formatter.format(formattedcomparePrice); //console.log(imageURL);
    // check if the compared price is greater then item price then only show the compared price
    var comparePriceHtml = "";
    if (comparePrice > parseFloat(itemPrice)) {
      comparePriceHtml = "<s>" + formattedcomparePrice + "</s>";
    }
    // total compared price for the item with quantity
    var totalListItemComparePrice = comparePrice * this.quantity;
    totalListItemComparePrice = totalListItemComparePrice / 100;
    totalListItemComparePrice = formatter.format(totalListItemComparePrice);
    // item original price
    var formattedItemPrice = itemPrice / 100;
    formattedItemPrice = formatter.format(formattedItemPrice);
    // line price
    var formattedItemLinePriceTotal = itemLinePriceTotal / 100;
    formattedItemLinePriceTotal = formatter.format(formattedItemLinePriceTotal);
    //final line item price
    var formattedFinalLineItemPrice = finalLineItemPrice / 100;
    formattedFinalLineItemPrice = formatter.format(formattedFinalLineItemPrice);
    //console.log("formattedItemLinePriceTotal: " + formattedItemLinePriceTotal);
    //Price after discount
    let showPrice = "";
    let itemPriceAfterDiscountStatus = false;
    let discountedMessage = "";
    let discountedMessageElement = "";
    if (this.discounts != null) {
      discountedMessage = this.discounts;
      if (Object.keys(discountedMessage).length > 0) {
        //console.log("DISCOUNT EXISTS");
        discountedMessageElement = "<span class='discountedMessage'>";
        $.each(discountedMessage, function (key, value) {
          discountedMessageElement += value.title;
        });
        discountedMessageElement += "</span>";
      }
    }
    var formattedItemPriceAfterDiscount;
    formattedItemPriceAfterDiscount = itemPriceAfterDiscount / 100;
    formattedItemPriceAfterDiscount = formatter.format(formattedItemPriceAfterDiscount);
    // if itemPriceAfterDiscount > 0 then set the status to true so you can interchange the values
    if (this.discounts.length > 0) {
      itemPriceAfterDiscountStatus = true;
    }
    //console.log("itemPriceAfterDiscount STATUS: " + itemPriceAfterDiscountStatus)
    // if it's true; then show the compared price as the main price this.price and main price as discounted price
    if (itemPriceAfterDiscountStatus) {
      //comparePriceHtml
      showPrice = '<span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0"><s>' + formattedItemPrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemPriceAfterDiscount + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>" + discountedMessageElement;
    } else {
      showPrice = '<span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0">' + comparePriceHtml + '<span class="price" data-key="' + itemID + '">' + formattedItemPrice + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>";
    }
    /* Bind the properties */

    let itemPropertiesElement = "";
    let itemPropertiesMainElement = "";
    var boolItemBoxType = false;
    var hideElementClass = "";
    var readonly = "";
    var justifyCenter = "";
    var formattedItemPriceMiniCart = formattedItemPrice;
    /* Item properties */
    if (this.properties != null) {
      itemProperties = this.properties;
      //console.log(itemProperties);
      if (Object.keys(itemProperties).length > 0) {
        itemPropertiesElement = "<ul>";
        $.each(itemProperties, function (key, value) {
          /* If box ID exists, then remove quantity + -  working */
          if (key == boxID) {
            // CUSTOM: 2 below lines are used if you want to remove the quantity + -
            // hideElementClass = "hide";
            // readonly = "readonly='readonly'";
            boolItemBoxType = true;
            justifyCenter = "justify-center ";
            // CUSTOM: if you do not want to show the price and compared price in cart and mini cart then open the below variables
            // formattedItemPrice="-";
            // formattedcomparePrice="-";
            // formattedItemLinePriceTotal="-";
            // formattedItemPriceMiniCart="";
          }
          if (key.indexOf("_") > -1) {} else {
            if (key != boxID) {
              itemPropertiesElement += "<li class='flex'><span>" + key + ": </span><span style='padding-left: 5px'>" + value + "</span>";
              itemPropertiesElement += "</li>";
            }
          }
          // Recharge - when subscription is via properties for older recharge version before November 2020
          recharge2020(key, value);
        });
        // Recharge 2020, check if it's a subscription, then bind the value in the UL
        if (recurringchecked) {
          itemPropertiesElement += "<li class='flex'><span>Recurring Delivery every " + frequency + " " + frequency_unit + ". Change or cancel anytime</span>";
          itemPropertiesElement += "</li>";
        }
        itemPropertiesElement += "</ul>";
        //console.log(itemPropertiesElement);
        itemPropertiesMainElement = itemPropertiesElement;
      } else {
        itemPropertiesElement = "";
      }
    }
    let sellingPlayInformation = "";
    if (this.selling_plan_allocation != undefined) {
      sellingPlayInformation = this.selling_plan_allocation.selling_plan.name;
    }
    /* check if variantTitle is NULL, then don't show variant */
    var variantTitle = this.variant_title;
    if (variantTitle == null) {
      variantTitle = "";
    }
    /* CUSTOM - if the product title contains "bag",  then disabled the quantity element
    To be applied for all the products with BoxID and Promo Offer
    */
    // if (this.product_title.toLowerCase() == "bag") {
    if (this.product_title.toLowerCase().indexOf("bag") >= 0 && cartBundleBoxID != "" || this.product_title.toLowerCase().indexOf("bag") >= 0 && boolPromoOffer) {
      //if you want to hide the quantity + - then enable the class below
      // hideElementClass="hide"
      justifyCenter = "justify-center ";
      readonly = "readonly='readonly'";
      disabled = "disabled ";
    }
    /* 
    LINE ITEM FOR THE MINI CART
    */
    //elements
    // remove anchor
    let removeAnchorElement = '<div class="remove js__cart-item-remove ' + removeExtraClass + '" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '"  data-cart-remove-variant="' + this.id + '" data-cart-line-count=' + lineCount + ">" + removeMiniCartTextOrIcon + "</div>";
    //quantity element
    var quantityElement = '<div class="cart-quantity-outer ' + disabled + justifyCenter + '"> <a  tabindex="0"  class="minus-qty ' + hideElementClass + '  font-zero" onclick="minusQuantity(' + lineCount + ')"   data-variant-id="' + itemID + '">' + minusIcon + '</a> <input aria-label="Quantity"  tabindex="-1"  data-limit="' + boolItemBoxType + '"  ' + readonly + '   onkeydown="return isNumeric(event);" type="text"  data-attr-raw-variant-quantity="94" data-cart-line-count="' + lineCount + '" class="cart__quantity-selector js__cart__quantity-selector" name="updates[]" id="updates_' + itemID + '" value="' + this.quantity + '" maxlength="3" size="3"> <a  tabindex="0"  class="plus-qty ' + hideElementClass + '  font-zero" onclick="plusQuantity(' + lineCount + ')"     data-variant-id="' + itemID + '">' + plusIcon + "</a> </div>";
    //vendor element
    let vendorElement = '<span class="subheading uppercase">' + this.vendor + "</span>";
    var lineItem;
    lineItem = '<li class="flex-wrap js__cart-table-item-row" data-cart-line-count=' + lineCount + ' data-handle="' + handle + '" data-variant-id=' + itemID + '><div class="image-section"> <a href="' + this.url + '"><img alt="' + imageAlt + '" src="' + imageURL + '""> </a> </div>';
    lineItem += '<div class="content"><h5><a href="' + this.url + '">' + this.product_title + "</a></h5>" + removeAnchorElement + "";
    if (sellingPlayInformation != "") {
      lineItem += '<p class="capitalize">' + sellingPlayInformation + "</p>";
    }
    if (itemPropertiesElement != "") {
      lineItem += '<p class="capitalize">' + itemPropertiesElement + "</p>";
    }
    if (variantTitle != "") {
      lineItem += '<p class="capitalize">' + variantTitle + "</p>";
    }
    lineItem += showPrice + '<div class="flex-space-between"><p class="hide">Qty ' + this.quantity + "</p>" + quantityElement;
    //lineItem += removeAnchorElement + "</div></div>";
    // !! NEED TO CHECK WITH DEV - why we using this variable here
    lineItem += "<span class='price'>" + formattedItemPriceAfterDiscount + "</span></div></div>";
    lineItem += "</li>";
    /* Bind the line item to the list */
    $(".js__ajax-products-bind").append(lineItem);
    //LINE ITEM FOR THE CART PAGE
    if ($(".cart-list")[0]) {
      //classLineItem = ".js__set-line-item-price";
      var cartLineItem = "";
      cartLineItem = '<div class="cart-list__items cart-table-body js__cart-table-item-row flex" data-cart-line-count="' + lineCount + '" data-attr-compare-price="" data-variant-id="' + itemID + '"><div class="cart-list__items__columns"><div class="image-section "><img class="img-responsive img-thumbnail item-image" src="' + imageURL + '" alt="' + imageAlt + '"></div> <div class="content">';
      // show vendor on cart page
      if (showVendorOnCartPage) {
        cartLineItem += vendorElement;
      }
      cartLineItem += '<a class="item-name" href="' + this.url + '"> <span class="item-title">' + this.product_title + " </span></a>";
      cartLineItem += '<div class="cart-list__variant-properties">';
      if (sellingPlayInformation != "") {
        cartLineItem += '<span class="capitalize">' + sellingPlayInformation + "</span>";
      }
      if (itemPropertiesElement != "") {
        cartLineItem += '<span class="capitalize">' + itemPropertiesElement + "</span>";
      }
      if (variantTitle != "") {
        cartLineItem += '<span class="capitalize">' + variantTitle + "</span>";
      }
      cartLineItem += "</div>";
      cartLineItem += '<a class="remove btn-border-small-black" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '" href="javascript:;">remove</a>  </div>  </div>  <div class="cart-list__items__columns">';
      cartLineItem += showPrice;
      cartLineItem += "</div>";
      cartLineItem += '<div class="cart-list__items__columns quantity" data-variant-id="' + itemID + '"> ' + quantityElement + '  <span class="js__out-of-stock"></span>';
      // ** Remove action is added here too
      cartLineItem += '</div>';
      cartLineItem += '<div class="cart-list__items__columns total-price price-wrapper" data-head="Total"> <span class="js__set-line-item-price" data-attr-price="' + itemPrice + '" data-attr-compare-price=' + totalListItemComparePrice + '><s class="hide">' + totalListItemComparePrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemLinePriceTotal + "</span> </span>";
      // ** Remove element is added here too
      //cartLineItem +="<a class=' remove btn-border-small-black ipad-block ' data-cart-line-count='" +lineCount +"' data-variant-id='" +itemID +"' href='javascript:;'>remove</a> ";
      cartCountEmptyValue += " </div></div>";
      $(".cart-list").append(cartLineItem);
    }
    lineCount++;
  });
}
//CALCULATE TOTAL OF THE CART
function quickCartTotal(data) {
  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
  }
  let total = cartObject.items_subtotal_price;
  total = total / 100;
  total = formatter.format(total);
  $(".js__cart-total").html(total);
  $(".js__ajax-cart-total").html("" + total);
  $(".js__ajax-cart-total").show();
  $(".js__ajax-cart-count").html(cartObject.item_count);
  $(".js__top-cart-form-actions").show();
  $(".js__cart-expand ").removeClass("empty-cart");

  //update affirm only if the div for affirm exists on the page
  let newprice = cartObject.items_subtotal_price;
  if ($(".affirm-as-low-as")[0]) {
    updateAffirmPromos(newprice);
  }
  function updateAffirmPromos(newPrice) {
    //Update the wrapper elements' attributes in the DOM

    $(".affirm-as-low-as").attr("data-amount", newPrice);

    //Call affirm.ui.refresh to re-render the promotional messaging componenets
    affirm.ui.refresh();
  }
}
function calculateSubTotalWithDiscount() {
  let subTotal = 0;
  let discount = 0;
  let total = 0;
  let lineItemComparePrice = 0;
  let itemPrice = 0;
  let quantity = 0;
  // ! PENDING - Here the quantity is static which comes from the page load only - voa cart Lib,
  // ! need to update this function to get the quantity of the line item
  /*
  1. loop through the cart items
  2. just to get the compared price - loop through the cartLib
  3. match the variant id with the cartLib ID
  4. If it matches, then get the compared price
  */
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => res.json()).then(data => {
    $.each(data.items, function (key, value) {
      let variantID = value.id;
      let quantity = value.quantity;
      $.each(cartLib, function (key, cartLibvalue) {
        if (variantID == cartLibvalue.id) {
          if (cartLibvalue.comparePrice != "") {
            lineItemComparePrice = parseInt(cartLibvalue.comparePrice) * quantity;
          } else {
            lineItemComparePrice = parseInt(value.final_line_price);
          }
        }
      });
      itemPrice = parseInt(value.price) * quantity;
      //console.log("itemPrice: " + itemPrice);
      subTotal += lineItemComparePrice;
      console.log("subTotal: " + subTotal);
      discount += lineItemComparePrice - itemPrice;
      //console.log("discount: " + discount);
    });
    total = data.total_price;
    //format
    console.log("discountdiscount" + discount);
    if (discount > 0) {
      console.log("discountdiscount" + discount);
      $(".js__cartSubtotalDiscountWraper").css("display", "flex");
    } else {
      $(".js__cartSubtotalDiscountWraper").hide();
    }
    subTotal = subTotal / 100;
    subTotal = formatter.format(subTotal);
    discount = discount / 100;
    discount = formatter.format(discount);
    total = total / 100;
    total = formatter.format(total);
    console.log("data.item_count" + data.item_count);
    if (data.item_count > 0) {
      $(".js__cart-sub-total").html(subTotal);
      $(".js__cart-total-saved").html("-" + discount);
      $(".js__cart-total").html(total);
      if (showCartCountInTopNav) {
        $(".js__ajax-cart-count").show();
        $(".js__ajax-cart-count").html(data.item_count);
      }
      $(".free-shipping").show();
      //show/hide js__cartSubtotalDiscountWraper - if you want to show subtotal and discount
      showCartSubTotalDiscountSection ? $(".js__cartSubtotalDiscountWraper").removeClass("hide") : console.log("SubTotal Discount Wrapper: NOT visible");
    } else {
      /* 
      update cart item count = 0
      hide the totals
      hide checkout buttons
      update the icon cart with a different icon
      */
      $(".js__ajax-products-bind").html('<li class="empty-mini-cart"><div class="width-100"> <p class="">Your cart is empty</p> </div></li>');
      $(".freq-product-list").hide();
      $(".free-shipping").hide();
      $(".js__ajax-cart-count").html(cartCountEmptyValue);
      $(".js__ajax-cart-total").hide();
      $(".js__top-cart-form-actions").hide();
      $(".js__show-cart-items-section").hide();
      $(".empty-cart-section").show();
      $(".js__cart-expand ").addClass("empty-cart");
      //change the icon for the top cart, if required
      showEmptyCartIcon ? $(".js__update-cart-icon").addClass("empty-cart") : console.log("Top Cart Icon: NOTchanged");
    }
  });
  /* loop through eachcart item and get the compared price and actual price */
  // if (typeof cartLib !== "undefined") {
  //   $.each(cartLib, function (key, value) {
  //     quantity = parseInt(value.quantity);
  //     console.log("quantity: " + quantity);
  //     if (value.comparePrice != "") {
  //       lineItemComparePrice =
  //         parseInt(value.comparePrice) * quantity + lineItemComparePrice;
  //     } else {
  //       console.log("compare price not in cartlib");
  //       lineItemComparePrice = parseInt(value.price) * quantity;
  //     }
  //     console.log("lineItemComparePrice: " + lineItemComparePrice);
  //     itemPrice = parseInt(value.price) * quantity;
  //     //console.log("itemPrice: " + itemPrice);
  //     subTotal += lineItemComparePrice;
  //     console.log("subTotal: " + subTotal);
  //     discount += lineItemComparePrice - itemPrice;
  //     //console.log("discount: " + discount);
  //   });
  //   total = CartJS.cart.total_price;
  //   //format
  //   subTotal = subTotal / 100;
  //   subTotal = formatter.format(subTotal);
  //   discount = discount / 100;
  //   discount = formatter.format(discount);
  //   total = total / 100;
  //   total = formatter.format(total);
  // }
  // if (CartJS.cart.item_count > 0) {
  //   $(".js__cart-sub-total").html(subTotal);
  //   $(".js__cart-total-saved").html("-" + discount);
  //   $(".js__cart-total").html(total);
  //   if (showCartCountInTopNav) {
  //     $(".js__ajax-cart-count").show();
  //     $(".js__ajax-cart-count").html(CartJS.cart.item_count);
  //   }
  //   $(".free-shipping").show();
  //   //show/hide js__cartSubtotalDiscountWraper - if you want to show subtotal and discount
  //   showCartSubTotalDiscountSection
  //     ? $(".js__cartSubtotalDiscountWraper").removeClass("hide")
  //     : console.log("SubTotal Discount Wrapper: NOT visible");
  // } else {
  //   /* 
  //   update cart item count = 0
  //   hide the totals
  //   hide checkout buttons
  //   update the icon cart with a different icon
  //   */
  //   $(".js__ajax-products-bind").html(
  //     '<li class="empty-mini-cart"><div class="width-100"> <p class="">Your cart is empty</p> </div></li>'
  //   );
  //   $(".freq-product-list").hide();
  //   $(".free-shipping").hide();
  //   $(".js__ajax-cart-count").html(cartCountEmptyValue);
  //   $(".js__ajax-cart-total").hide();
  //   $(".js__top-cart-form-actions").hide();
  //   $(".js__show-cart-items-section").hide();
  //   $(".empty-cart-section").show();
  //   $(".js__cart-expand ").addClass("empty-cart");
  //   //change the icon for the top cart, if required
  //   showEmptyCartIcon
  //     ? $(".js__update-cart-icon").addClass("empty-cart")
  //     :
  //     console.log("Top Cart Icon: NOTchanged");
  // }
}
/*
  CUSTOM-- for the BUILDER
  THIS FUNCTION IS USED WHEN THERE IS NO QUANTITY BOX VISIBLE AGAINST THE ITEM
  //Variest from theme to theme
   1. Loop through cart items
   2. If item has property > 0 
   3. Then check for boxID 
   4. Save the BoxID in a variable
   5. Then go through the second cart item
   6. if currentItemPropertyBoxID = savedItemPropertyBoxID
   7. Then remove the item
   8. Else do not do anything
*/
var savedItemPropertyBoxID = "";
var currentItemPropertyBoxID = "";
var clickedRemoveItemStatus = false;
var currentItemID = "";
$(document).on("click", ".remove", function () {
  //console.log("REMOVE CLICKED");
  var howManyItemsToDelete = 0;
  var howManyVariantIDToDelete = [];
  let variantID = parseInt($(this).attr("data-variant-id"));
  let itemLineCount = parseInt($(this).attr("data-cart-line-count"));
  //console.log("itemLineCount: " + itemLineCount);
  let extraItemLineCount = 1;
  /* offer main product ID and bool*/
  let productID = "";
  //Run properties loop and set clickRemove status = true if BoxID is found
  $(CartJS.cart.items).each(function () {
    if (itemLineCount == extraItemLineCount) {
      //console.log("clicked - variantID : " + variantID);
      productID = this.product_id;
      $.each(this.properties, function (key, value) {
        //console.log("key: " + key);
        if (key == boxID) {
          //console.log("key2: " + key);
          savedItemPropertyBoxID = value;
          clickedRemoveItemStatus = true;
        }
        /* CUSTOM: Checking deleted item is main product of promo offer*/
        if (key == "_promoOffer") {
          if (productID == promoOffer_BlackFriday_ProductID) {
            boolPromoOffer_BlackFriday_ProductID = true;
          }
        }
      });
    }
    extraItemLineCount = extraItemLineCount + 1;
    //console.log("clickedRemoveItemStatus: " + clickedRemoveItemStatus);
    if (clickedRemoveItemStatus) {
      //console.log("clickedRemoveItemStatus: " + true);
      clickedRemoveItemStatus = false;
      return false;
    }
  });
  extraItemLineCount = 1;
  /* CUSTOM: Loop through items and properties */
  $(CartJS.cart.items).each(function () {
    currentItemID = this.id;
    //console.log("LoopCurrentItemID: " + currentItemID);
    $.each(this.properties, function (key, value) {
      //console.log("key4: " + key);
      //console.log("boxID4: " + boxID);
      if (key == boxID) {
        //console.log("Property Match");
        currentItemPropertyBoxID = value;
        //console.log("currentItemPropertyBoxID: " + currentItemPropertyBoxID);
        //console.log("savedItemPropertyBoxID: " + savedItemPropertyBoxID);
        if (currentItemPropertyBoxID == savedItemPropertyBoxID) {
          //console.log("remove the current item");
          extraItemLineCount = 1;
          howManyItemsToDelete = howManyItemsToDelete + 1;
          howManyVariantIDToDelete.push(currentItemID);
          //Remove the product that clicked
        } else {
          extraItemLineCount = extraItemLineCount + 1;
        }
      } else {
        //console.log("BOX ID ISN'T THERE IN PRODUCT");
        //removeItem(itemLineCount);
      }
    });
    //console.log("howManyVariantIDToDelete: " + howManyVariantIDToDelete);
  });
  //console.log("TOTAL: howManyVariantIDToDelete: " + howManyVariantIDToDelete);
  //console.log("TOTAL howManyItemsToDelete: " + howManyItemsToDelete);
  if (howManyItemsToDelete == 0) {
    //console.log("ITEM TO DELETE: " + 0);
    removeItem(itemLineCount);
  } else {
    //console.log("TOTAL # of item to delete > 0");
    /* 
    Remove the items depending upon how many are to be deleted
    Run the loop again and delete them one by one 
    */
    //console.log(howManyVariantIDToDelete.length);
    let currentItemLoop = 1;
    // NOTE: used "removeItemById" as for this particular project ..
    for (var n = 0; n < howManyVariantIDToDelete.length; ++n) {
      removeItemById(howManyVariantIDToDelete[n]);
      //debugger;
      // $(CartJS.cart.items).each(function () {
      //   //console.log("howManyVariantIDToDelete");
      //   //console.log(howManyVariantIDToDelete[n]);
      //   //console.log(this.title);
      //   //console.log(this.properties);
      //   //debugger;
      //   if (jQuery.isEmptyObject(this.properties)) {
      //     //console.log("Property is empty");
      //     currentItemLoop = currentItemLoop + 1;
      //   } else {
      //     $.each(this.properties, function (key, value) {
      //       if (key == boxID ) {
      //         //console.log("FINAL - BOX ID FOUND 1 by 1");
      //         currentItemPropertyBoxID = value;
      //         if (currentItemPropertyBoxID == savedItemPropertyBoxID) {
      //           //console.log("remove the final loop item");
      //           removeItemById(howManyVariantIDToDelete[n]);
      //           currentItemLoop = 1;
      //           //Remove the product that clicked
      //         } else {
      //           currentItemLoop = currentItemLoop + 1;
      //         }
      //       }
      //       else
      //       {
      //         //console.log("FINAL - BOX ID NOT FOUND 1 by 1");
      //       }
      //     });
      //     if (currentItemLoop == 1) {
      //       return false;
      //     }
      //   }
      // });
    }
  }
  showHideEmptyCart();
});
function showHideEmptyCart() {
  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
}
/*
PROGRESS BAR
*/
function progressBar() {
  if (showProgressBar) {
    var totalAmount = CartJS.cart.total_price / 100;
    var freeShippingAmount = parseFloat($(".js__free-shipping-limit").html());
    var freeShippingRemaningAmount = freeShippingAmount - totalAmount;
    var freeShippingPercentage = 100;
    if (freeShippingRemaningAmount > 0) {
      freeShippingPercentage = totalAmount * 100 / freeShippingAmount;
      $(".js__free-shipping-limit-message").show();
      $(".js__free-shipping-message").hide();
    } else {
      $(".js__free-shipping-limit-message").hide();
      $(".js__free-shipping-message").show();
    }
    $(".js__free-shipping-remaning-amount").html(formatter.format(freeShippingRemaningAmount));
    $(".js__free-shipping__progress-bar").attr("data-percentage", freeShippingPercentage);
    $(".js__free-shipping__progress-bar").children("span").css("width", freeShippingPercentage + "%");
  }
}
/*
ADDONS
NOTE:: CONFUSING CODE FOR THE ADDONS - WILL NEED TO CLEAN IT A BIT
1. Try to get all the addon handles for the items which are in the cart
2. Create an array for item>addon
3. Loop through all the cart items and addon
4. CHECK - if addon is already there in the list, then the same 2nd addon should not be visible
*/
$(document).ready(function ($) {
  $(".js__addon-add-to-cart").click(function () {
    let quantity = 1;
    let addonSelectedVariantID = $(this).attr("data-attr-variantid");
    cartAddItemAddon(addonSelectedVariantID, quantity);
  });
  $(".js__addon-add-to-cart").keypress(function () {
    var keycode = event.keyCode || event.which;
    if (keycode == "13") {
      event.preventDefault();
      let quantity = 1;
      let addonSelectedVariantID = $(this).attr("data-attr-variantid");
      cartAddItemAddon(addonSelectedVariantID, quantity);
    }
  });
});
function cartAddItemAddon(addonSelectedVariantID, addonQuantity) {
  CartJS.addItem(addonSelectedVariantID, addonQuantity, {}, {
    success: function (data, textStatus, jqXHR) {
      //console.log("success");
      /* Pending - Remove the selected addon when add to cart is clicked */
    },
    error: function (jqXHR, textStatus, errorThrown) {
      //console.log("error");
    }
  });
}
function addons() {
  //console.log("addons");
  /*Hide repeating addons*/
  var cartAddons = "";
  $(".js__top-cart-addons li").each(function (index) {
    // update this with variantID
    var addoneHandle = $(this).attr("data-handler");
    // if cartAddon is null,
    if (cartAddons == "") {
      // save the addonHandle
      cartAddons = addoneHandle;
    } else {
      //set bool value to see if the addons is present in the addon list or not
      // by default it's false
      var boolCartAddons = false;
      // going through the string and checking if the current addon handle = the addon
      //handle present in the string
      var cartAddons2 = cartAddons.split(",");
      for (var a = 0; a < cartAddons2.length; a++) {
        if ($(this).attr("data-handler") == cartAddons2[a]) {
          // if present, then hide it
          $(this).hide();
          boolCartAddons = true;
        }
      }
      // add the new addon handle to the string
      if (boolCartAddons == false) {
        cartAddons = cartAddons + "," + addoneHandle;
      }
    }
    //console.log(cartAddons);
    /* Hide the addons from the addon list, if the addon is present in the cart */
    var boolItemCartAddon = false;
    $(".js__ajax-products-bind li").each(function (index) {
      var itemHandle = $(this).attr("data-handle");
      //console.log("itemHandle"+itemHandle);
      //console.log("addoneHandle"+addoneHandle)
      if (addoneHandle == itemHandle) {
        boolItemCartAddon = true;
      }
    });
    if (boolItemCartAddon == true) {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
  /* Hide the complete section if there are no addons */
  var boolAddonExist = false;
  $(".js__top-cart-addons li").each(function (index) {
    if ($(this).css("display") != "none") {
      boolAddonExist = true;
    }
  });
  //console.log("boolAddonExist"+boolAddonExist);
  if (boolAddonExist == false) {
    //console.log("if");
    $(".js__freq-bought-products").hide();
  } else {
    //console.log("else");
    $(".js__freq-bought-products").show();
  }
}
//Addons are fetched from the schemas; Varies from theme to theme
setTimeout(function () {
  addons();
}, 1000);

//loop through cart items to get property on the basis of variant ID
function loopThroughCartItems_on_VariantID(variantID) {
  let currentVariantID = "";
  let properties = "";
  $(CartJS.cart.items).each(function () {
    // currentVariantID = this.id;
    if (variantID == this.id) {
      properties = this.properties;
      return false;
    }
  });
  return properties;
}
function loopThroughCartItems_on_ProductID(productID) {
  let variantID = "";
  $(CartJS.cart.items).each(function () {
    // currentVariantID = this.id;
    if (productID == this.product_id) {
      variantID = this.id;
      return false;
    }
  });
  return variantID;
}
function recharge2020(key, value) {
  if (key == "shipping_interval_frequency") {
    frequency = value;
    recurringchecked = "true";
  }
  if (key == "shipping_interval_unit_type") {
    if (frequency == "1") {
      if (value == "Days") {
        frequency_unit = "Day";
      } else if (value == "Months") {
        frequency_unit = "Month";
      } else if (value == "Weeks") {
        frequency_unit = "Week";
      }
    } else {
      frequency_unit = value;
    }
  }
}
"use strict";

jQuery(function () {
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
  $(".js__blog-category li").each(function () {
    var liPath = $(this).children("a").attr("href").toLowerCase();
    console.log(liPath);
    console.log(path.toLowerCase());
    if (liPath === path.toLowerCase()) {
      $(this).children("a").addClass("active");
    }
  });
  $(".dropdown-select option").each(function () {
    if (this.value.toLowerCase() == path.toLowerCase()) {
      this.setAttribute("selected", true);
    }
  });
  $(".dropdown-select").change(function () {
    try {
      var dropdown = $(".dropdown-select").val();
      //first hide all tabs again when a new option is selected
      $(".tab-content").hide();
      //then show the tab content of whatever option value was selected
      $("#" + "tab-" + dropdown).show();
    } catch {}
  });
  var heroSlider = new Swiper(".js__hero-banner-slider", {
    slidesPerView: 1,
    autoHeight: true,
    resistance: false,
    shortSwipes: false,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next-hero-banner",
      prevEl: ".swiper-button-prev-hero-banner"
    }
  });
  var categorySlider = new Swiper(".js__category-slider", {
    slidesPerView: "auto",
    autoHeight: true,
    resistance: false,
    shortSwipes: false,
    loop: false,
    spaceBetween: 60,
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next-categeoty-slider",
      prevEl: ".swiper-button-prev-categeoty-slider"
    }
  });
  var threeColumnSlider = new Swiper(".js__three-column-slider", {
    slidesPerView: 3,
    spaceBetween: 10,
    resistance: false,
    shortSwipes: false,
    navigation: {
      nextEl: ".swiper-button-next-three-column-slider",
      prevEl: ".swiper-button-prev-three-column-slider"
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      481: {
        slidesPerView: 2
      },
      769: {
        slidesPerView: 3
      }
    }
  });
  var threeColumnReviewSlider = new Swiper(".js__three-column-review-slider", {
    slidesPerView: 3,
    spaceBetween: 10,
    resistance: false,
    shortSwipes: false,
    navigation: {
      nextEl: ".swiper-button-next-review-slider",
      prevEl: ".swiper-button-prev-review-slider"
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      481: {
        slidesPerView: 2
      },
      769: {
        slidesPerView: 3
      }
    }
  });
  var buttonSlider = new Swiper(".js__buttons-slider", {
    slidesPerView: "auto",
    spaceBetween: 40,
    resistance: false,
    shortSwipes: false,
    navigation: {
      nextEl: ".swiper-button-next-buttons-slider",
      prevEl: ".swiper-button-prev-buttons-slider"
    }
  });
  var fiveColumnSliderSection = new Swiper(".js__five-column-slider-section", {
    slidesPerView: 5,
    spaceBetween: 10,
    resistance: false,
    shortSwipes: false,
    navigation: {
      nextEl: ".swiper-button-next-five-column-slider",
      prevEl: ".swiper-button-prev-five-column-slider"
    },
    breakpoints: {
      0: {
        slidesPerView: "auto"
      },
      769: {
        slidesPerView: 5
      }
    }
  });
  var twoColumnImageSliderSection = new Swiper(".js__two-column-image-slider", {
    slidesPerView: 2,
    spaceBetween: 20,
    resistance: false,
    shortSwipes: false,
    navigation: {
      nextEl: ".swiper-button-next-two-column-image-slider",
      prevEl: ".swiper-button-prev-two-column-image-slider"
    },
    breakpoints: {
      0: {
        slidesPerView: "auto"
      },
      601: {
        slidesPerView: 2
      }
    }
  });
  var threeColumnImageSliderSection = new Swiper(".js__three-column-image-slider", {
    slidesPerView: 3,
    spaceBetween: 10,
    resistance: false,
    shortSwipes: false,
    navigation: {
      nextEl: ".swiper-button-next-three-column-image-slider",
      prevEl: ".swiper-button-prev-three-column-image-slider"
    },
    breakpoints: {
      0: {
        slidesPerView: "auto"
      },
      601: {
        slidesPerView: 3
      }
    }
  });
  var threeColumnIconsSlider = new Swiper(".js__three-column-icons-slider", {
    slidesPerView: 3,
    spaceBetween: 60,
    resistance: false,
    shortSwipes: false,
    freeMode: true,
    loop: true,
    watchSlidesProgress: true,
    clickable: true,
    grabCursor: true,
    mousewheel: true,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 30
      },
      768: {
        slidesPerView: 3
      }
    }
  });
  var ArticleRelatedSlider = new Swiper("#js__article-related-slider", {
    slidesPerView: "auto",
    freeMode: false,
    watchSlidesProgress: true,
    resistance: false,
    shortSwipes: false,
    clickable: true,
    grabCursor: true,
    mousewheel: false,
    autoHeight: false,
    breakpoints: {
      0: {
        slidesPerView: "auto",
        spaceBetween: 20
      },
      769: {
        slidesPerView: "auto",
        spaceBetween: 40
      }
    }
  });
  var productSlider = new Swiper(".js__product-slider", {
    spaceBetween: 10,
    slidesPerView: "auto",
    freeMode: true,
    watchSlidesProgress: true,
    resistance: false,
    shortSwipes: false,
    clickable: true,
    grabCursor: true,
    mousewheel: false,
    navigation: {
      nextEl: ".swiper-button-next-product-slider",
      prevEl: ".swiper-button-prev-product-slider"
    }
  });
  var contactInfoSlider = new Swiper(".js__contact-info-slider", {
    slidesPerView: "auto",
    freeMode: false,
    watchSlidesProgress: true,
    resistance: false,
    shortSwipes: false,
    clickable: true,
    grabCursor: false,
    mousewheel: false,
    autoHeight: false,
    loop: true,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false
    },
    navigation: {
      nextEl: ".swiper-button-next-contact-slider",
      prevEl: ".swiper-button-prev-contact-slider"
    },
    breakpoints: {
      0: {
        slidesPerView: "auto",
        spaceBetween: 40
      },
      769: {
        slidesPerView: "auto",
        spaceBetween: 60
      }
    }
  });
  try {
    var pageTotal = parseInt($(".js__total-page").val());
    var currentPage = parseInt($(".js__current-page").val());
    var itemTotal = parseInt($(".js__items-count").val());
    var perPageItem = parseInt($(".js__perpage-item").val());
    var itemStart = 1;
    var itemEnd = 0;
    if (currentPage > 1) {
      itemStart = perPageItem * (currentPage - 1) + 1;
    }
    itemEnd = itemStart + perPageItem - 1;
    if (pageTotal == currentPage) {
      itemEnd = itemTotal;
    }
    $(".js__page-range").html(itemStart + " - " + itemEnd);
  } catch {}
  /* PDP
   $(".drop-down-outer select option").each(function () {
        if (this.value.toLowerCase() == path.toLowerCase()) {
          this.setAttribute("selected", true);
        }
      });
  Tab working */
  $(".tab-link").on("click", function () {
    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("tab-content");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablink = document.getElementsByClassName("tab-link");
    for (i = 0; i < tablink.length; i++) {
      tablink[i].className = tablink[i].className.replace(" active", "");
    }
    document.getElementById(dataId).style.display = "block";
    event.currentTarget.className += " active";
    /*PDP select*/
    $(".js__pdp-tab-select").val(dataId);
  });
  /* GLOBAL
  Scroll to particular Div with # value */
  $('a[href^="#"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));
    $('.tab-cat').removeClass(' active');
    $(this).addClass(' active');
    if (target.length) {
      event.preventDefault();
      $(".tab-head").hide();
      $("html, body").stop().animate({
        scrollTop: target.offset().top - 150
      }, 1000);
    }
  });
  $(".js__page-category-dropdown").change(function () {
    var value = $(this).val();
    var target = $("#" + value);
    $("html, body").animate({
      scrollTop: target.offset().top - 150
    }, 500);
  });
  // $(".js__accordian").children("li:first-child").addClass("active");
  /* accordion working about content in small screen*/
  $(".js__accordian").children("li").children("h5,h6,h3").click(function (e) {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(this).parent("li").parent(".js__accordian").children("li").children(".content").slideUp();
      $(this).parent("li").parent(".js__accordian").children("li").removeClass("active");
      $(this).parent("li").children(".content").slideDown();
      $(this).parent("li").addClass("active");
      /* $('html,body').animate({
        scrollTop: $(this).offset().top - 120
      }, 500);*/
    } else {
      $(this).parent("li").children(".content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });
  $(".js__btn-add-to-cart").click(function () {
    if ($(this).html().trim().toLowerCase() == "add to cart") {
      var selectedVariantID = $(this).attr("data-attr-variantid");
      selectedVariantID = parseInt(selectedVariantID);
      let cartSuccess = false;
      var quantity = 1;
      let items = [];
      /* For the main item */
      items.push({
        id: selectedVariantID,
        quantity: quantity
      });
      CartJS.addItems(items, {
        success: function (response, textStatus, jqXHR) {
          CartJS.getNote();
          console.log(response);
          // console.log(CartJS.cart);
          cartSuccess = true;
          if (getglobalLib("Mini_Cart") == "yes") {
            setTimeout(function () {
              /* Show message */
              fetch('/cart.js', {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(res => res.json()).then(data => {
                $("#CartSidebar").addClass("active");
                $("#cart_overlay").addClass("active");
                $("#js__header").addClass("cart-active");
              });
            }, 500);
          } else {
            window.location = "/cart";
          }
        },
        // Define an error callback to display an error message.
        error: function (jqXHR, textStatus, errorThrown) {
          showCartErrorMessage();
        }
      });
    }
  });
});
/** Dropdown **/

jQuery(function ($) {
  $(".js__dropdown_result").on("click", function () {
    if ($(".js__dropdown").css("display") == "none") {
      $(".js__dropdown").slideDown(300);
    } else {
      $(".js__dropdown").slideUp(300);
    }
    $(this).toggleClass("active");
  });
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
  $(".js__dropdown li a").each(function () {
    if (this.href === path) {
      $(this).addClass("active");
      console.log($(this).html());
      if ($(this).html() != "view all") {
        $(".js__dropdown_result").html($(this).html());
      }
      $(".js__dropdown").slideUp(300);
      $(".js__dropdown_result").removeClass("active");
    }
  });
});
/* Mini cart - Checkout Button visiblity fix for IOS Mobile */
var lastScroll = 0;
jQuery(document).ready(function ($) {
  $(".cart-sidebar__middle").addClass("safari-mobile");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll > lastScroll) {
      $(".cart-sidebar__middle").removeClass("safari-mobile");
    } else if (scroll < lastScroll) {
      $(".cart-sidebar__middle").addClass("safari-mobile");
    }
    lastScroll = scroll;
  });
});
/** Dropdown **/
jQuery(function ($) {
  /*Blog dropdown*/
  $(".js__blog-select").change(function () {
    window.location = $(this).val();
  });
  /*Dropdown selected*/
  $(".js__blog-select option").each(function (index) {
    var value = $(this).val().toLowerCase();
    if (window.location.href.toLowerCase().indexOf(value) > -1) {
      $(".js__blog-select").val($(this).val());
    }
  });
  $('input[type="checkbox"]').click(function () {
    if ($(this).is(":checked")) {
      //input element where you put value
      $(this).parent("label").addClass("active");
    } else if ($(this).is(":not(:checked)")) {
      $(this).parent("label").removeClass("active");
    }
  });
});

// jQuery(function () {
//   // Get the element
//   for (var i = 0; i < 50; i++) {
//     var marqueeFooter = document.querySelector(".js__marquee p");
//     // Create a copy of it
//     var cloneFooter = marqueeFooter.cloneNode(true);
//     // Inject it into the DOM
//     marqueeFooter.after(cloneFooter);
//   }
// });

jQuery(document).ready(function ($) {
  $(".tab-link").first().addClass("active");
  $(".shopify-section .tab-content").first().show();
});
"use strict";

jQuery(function () {
  //Nav - Open and Close Mini cart
  if (getglobalLib("Mini_Cart") == "yes") {
    $(".js__cart-expand").on("click", function () {
      $("#CartSidebar").toggleClass("active");
      $("#cart_overlay").toggleClass("active");
      $(this).addClass("active");
      $("#js__header").toggleClass("cart-active");
    });
    $("#js__cart-close").on("click", function () {
      $("#CartSidebar").removeClass("active");
      $("#cart_overlay").removeClass("active");
      $(".js__cart-expand").removeClass("active");
      $("#js__header").toggleClass("cart-active");
    });
    $(".js__cart-expand").attr("href", "javascript:void(0)");
  }
  /* Cart - Free Shipping Progress bar Visiblity */
  if (getglobalLib("Free_Shipping_progressbar") == "yes") {
    $(".js__progressbar_visiblity").removeClass("hide");
  }
  /* Remove mini cart from the cart page */
  if ($(".cart-table-body")[0]) {
    $("#CartSidebar").remove();
    $("#cart_overlay").remove();
    $("#js__header").removeClass("cart-active");
    $(".js__top-cart-form-actions").remove();
    $(".js__ajax-products-bind").remove();
    $(".mini-cart").removeClass("js__cart-expand");
    $(".mini-cart").attr("href", "/cart");
  }
  /* show no items in cart */
  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
  /*Quantity Plus Minus for the textbox */
  $(".js__product-single__quantity .js__minus-qty").click(function () {
    decreaseQuantity();
  });
  $(".js__product-single__quantity .js__plus-qty").click(function () {
    increaseQuantity();
  });
  function increaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();
    productQuantity++;
    $(".js__quantity-selector").val(productQuantity);
  }
  function decreaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();
    if (productQuantity > 1) {
      productQuantity--;
    }
    $(".js__quantity-selector").val(productQuantity);
  }
});

/* 
  NOTIFICATIONS SECTION
  Show Noticiations On Success and Error
  Note: This function isn't being used in every theme
  Feel free to comment/uncomment as per the functionality
  */
function showCartSuccessMessage() {
  setTimeout(openMiniCart, 500);
  $("#cart-message").addClass("message-success");
  $("#cart-message").removeClass("message-error");
  $("#cart-message").html("Successfully added to cart!");
  $("#cart-message").show();
  setTimeout(function () {
    $("#cart-message").hide();
  }, 5000);
}
function showCartErrorMessage() {
  $("#cart-message").removeClass("message-success");
  $("#cart-message").addClass("message-error");
  $("#cart-message").html("Sorry! Seems like the product is out of stock");
  $("#cart-message").show();
  setTimeout(function () {
    $("#cart-message").hide();
  }, 5000);
}
function openMiniCart() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(res => res.json()).then(data => {
    $("#CartSidebar").toggleClass("active");
    $("#cart_overlay").toggleClass("active");
    $("#js__header").toggleClass("cart-active");
  });
}

/* EVENT: When the cart request is completed everytime the below function is run */
$(document).on("cart.requestComplete", function (event, cart) {
  console.log("On cart request complete");
  reloadAjaxCartItemUsingCartAjaxObject(cart);
  //Progress Bar of shipping in cart and mini cart; Varies from theme to theme
  progressBar();
  //Show and hide empty cart depending upon the cart items
  setTimeout(function () {
    calculateSubTotalWithDiscount();
    addons();
  }, 1000);
});

// $(document).on("cart.requestStarted", function (event, cart) {console.log("Request started"); });
//$(document).on("cart.ready", function (event, cart) {});

/* currency formatter */
const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
"use strict";

jQuery(function () {
  /* Footer - Accordion Visiblity */
  if (getglobalLib("Footer_Accordion") == "yes") {
    $(".js__accordion-toggle-visiblity").addClass("accordion-toggle-footer");
    $(".js__accordion-content-visiblity").addClass("accordion-content-footer");
  }
  /* FAQ - Category Sidebar Visiblity */
  if (getglobalLib("FAQ_Side_Panel") == "yes") {
    $(".js__faq-category-side-panel").removeClass("hide");
  }
  if (getglobalLib("Product_Recommendation_Slider") == "on") {
    var productRecSlider = new Swiper("#js__pdp-recommendation-slider", {
      slidesPerView: "auto",
      freeMode: true,
      watchSlidesProgress: true,
      clickable: true,
      grabCursor: true,
      resistance: false,
      shortSwipes: false,
      mousewheel: true,
      navigation: {
        nextEl: ".swiper-button-next-product-rec-slider",
        prevEl: ".swiper-button-prev-product-rec-slider"
      },
      breakpoints: {
        600: {
          slidesPerView: "auto",
          spaceBetween: 20
        },
        601: {
          slidesPerView: "auto",
          spaceBetween: 40
        }
      }
    });
  }
});
"use strict";

jQuery(function () {
  /* Global
  Announcement Slider */
  $(".js__announcement-slider").not(".slick-initialized").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: false,
    vertical: true,
    cssEase: "ease-in-out",
    adaptiveHeight: false
  });
  /* Announcement 
  Close on Click  */
  $("#announcement-close").on("click", function () {
    $(".announcement-bar").hide();
    $("body").removeClass("announcement-visible");
  });

  /* If Hero banner add Class  */
  $("div").hasClass("inner-hero-section") === !0 && $("body").addClass("inner-hero-page");
  $("div").hasClass("no-bg-image-collection") === !0 && $("body").removeClass("inner-hero-page");

  /* MEGAMENU
    active link while submenu open */
  if ($(window).width() > 1200) {
    $(".has-sub-nav-0 .site-nav__link,.has-sub-nav-0 .sub-nav").mouseover(function () {
      $(".has-sub-nav-0 .site-nav__link").addClass("hover-submenu");
      $(".has-sub-nav-0 .sub-nav").css("visibility", "visible");
      $(".has-sub-nav-0 .sub-nav").css("opacity", "1");
    });
    $(".has-sub-nav-0 .site-nav__link,.has-sub-nav-0 .sub-nav").mouseout(function () {
      $(".has-sub-nav-0 .site-nav__link").removeClass("hover-submenu");
      $(".has-sub-nav-0 .sub-nav").css("visibility", "hidden");
      $(".has-sub-nav-0 .sub-nav").css("opacity", "0");
    });
    $(".has-sub-nav-1 .site-nav__link,.has-sub-nav-1 .sub-nav").mouseover(function () {
      $(".has-sub-nav-1 .site-nav__link").addClass("hover-submenu");
      $(".has-sub-nav-1 .sub-nav").css("visibility", "visible");
      $(".has-sub-nav-1 .sub-nav").css("opacity", "1");
    });
    $(".has-sub-nav-1 .site-nav__link,.has-sub-nav-1 .sub-nav").mouseout(function () {
      $(".has-sub-nav-1 .site-nav__link").removeClass("hover-submenu");
      $(".has-sub-nav-1 .sub-nav").css("visibility", "hidden");
      $(".has-sub-nav-1 .sub-nav").css("opacity", "0");
    });
    $(".has-sub-nav-2 .site-nav__link,.has-sub-nav-2 .sub-nav").mouseover(function () {
      $(".has-sub-nav-2 .site-nav__link").addClass("hover-submenu");
      $(".has-sub-nav-2 .sub-nav").css("visibility", "visible");
      $(".has-sub-nav-2 .sub-nav").css("opacity", "1");
    });
    $(".has-sub-nav-2 .site-nav__link,.has-sub-nav-2 .sub-nav").mouseout(function () {
      $(".has-sub-nav-2 .site-nav__link").removeClass("hover-submenu");
      $(".has-sub-nav-2 .sub-nav").css("visibility", "hidden");
      $(".has-sub-nav-2 .sub-nav").css("opacity", "0");
    });
    $(".has-sub-nav-3 .site-nav__link,.has-sub-nav-3 .sub-nav").mouseover(function () {
      $(".has-sub-nav-3 .site-nav__link").addClass("hover-submenu");
      $(".has-sub-nav-3 .sub-nav").css("visibility", "visible");
      $(".has-sub-nav-3 .sub-nav").css("opacity", "1");
    });
    $(".has-sub-nav-3 .site-nav__link,.has-sub-nav-3 .sub-nav").mouseout(function () {
      $(".has-sub-nav-3 .site-nav__link").removeClass("hover-submenu");
      $(".has-sub-nav-3 .sub-nav").css("visibility", "hidden");
      $(".has-sub-nav-3 .sub-nav").css("opacity", "0");
    });
    $(".has-sub-nav-4 .site-nav__link,.has-sub-nav-4 .sub-nav").mouseover(function () {
      $(".has-sub-nav-4 .site-nav__link").addClass("hover-submenu");
      $(".has-sub-nav-4 .sub-nav").css("visibility", "visible");
      $(".has-sub-nav-4 .sub-nav").css("opacity", "1");
    });
    $(".has-sub-nav-4 .site-nav__link,.has-sub-nav-4 .sub-nav").mouseout(function () {
      $(".has-sub-nav-4 .site-nav__link").removeClass("hover-submenu");
      $(".has-sub-nav-4 .sub-nav").css("visibility", "hidden");
      $(".has-sub-nav-4 .sub-nav").css("opacity", "0");
    });
    $(".has-sub-nav-5 .site-nav__link,.has-sub-nav-5 .sub-nav").mouseover(function () {
      $(".has-sub-nav-5 .site-nav__link").addClass("hover-submenu");
      $(".has-sub-nav-5 .sub-nav").css("visibility", "visible");
      $(".has-sub-nav-5 .sub-nav").css("opacity", "1");
    });
    $(".has-sub-nav-5 .site-nav__link,.has-sub-nav-5 .sub-nav").mouseout(function () {
      $(".has-sub-nav-5 .site-nav__link").removeClass("hover-submenu");
      $(".has-sub-nav-5 .sub-nav").css("visibility", "hidden");
      $(".has-sub-nav-5 .sub-nav").css("opacity", "0");
    });
    $(".has-big-nav-0 .site-nav__link,.has-big-nav-0 .big-nav").mouseover(function () {
      $(".has-big-nav-0 .site-nav__link").addClass("hover-submenu");
      $(".has-big-nav-0 .big-nav").css("visibility", "visible");
      $(".has-big-nav-0 .big-nav").css("opacity", "1");
    });
    $(".has-big-nav-0 .site-nav__link,.has-big-nav-0 .big-nav").mouseout(function () {
      $(".has-big-nav-0 .site-nav__link").removeClass("hover-submenu");
      $(".has-big-nav-0 .big-nav").css("visibility", "hidden");
      $(".has-big-nav-0 .big-nav").css("opacity", "0");
    });
    $(".has-big-nav-1 .site-nav__link,.has-big-nav-1 .big-nav").mouseover(function () {
      $(".has-big-nav-1 .site-nav__link").addClass("hover-submenu");
      $(".has-big-nav-1 .big-nav").css("visibility", "visible");
      $(".has-big-nav-1 .big-nav").css("opacity", "1");
    });
    $(".has-big-nav-1 .site-nav__link,.has-big-nav-1 .big-nav").mouseout(function () {
      $(".has-big-nav-1 .site-nav__link").removeClass("hover-submenu");
      $(".has-big-nav-1 .big-nav").css("visibility", "hidden");
      $(".has-big-nav-1 .big-nav").css("opacity", "0");
    });
    $(".has-big-nav-2 .site-nav__link,.has-big-nav-2 .big-nav").mouseover(function () {
      $(".has-big-nav-2 .site-nav__link").addClass("hover-submenu");
      $(".has-big-nav-2 .big-nav").css("visibility", "visible");
      $(".has-big-nav-2 .big-nav").css("opacity", "1");
    });
    $(".has-big-nav-2 .site-nav__link,.has-big-nav-2 .big-nav").mouseout(function () {
      $(".has-big-nav-2 .site-nav__link").removeClass("hover-submenu");
      $(".has-big-nav-2 .big-nav").css("visibility", "hidden");
      $(".has-big-nav-2 .big-nav").css("opacity", "0");
    });
    $(".has-big-nav-3 .site-nav__link,.has-big-nav-3 .big-nav").mouseover(function () {
      $(".has-big-nav-3 .site-nav__link").addClass("hover-submenu");
      $(".has-big-nav-3 .big-nav").css("visibility", "visible");
      $(".has-big-nav-3 .big-nav").css("opacity", "1");
    });
    $(".has-big-nav-3 .site-nav__link,.has-big-nav-3 .big-nav").mouseout(function () {
      $(".has-big-nav-3 .site-nav__link").removeClass("hover-submenu");
      $(".has-big-nav-3 .big-nav").css("visibility", "hidden");
      $(".has-big-nav-3 .big-nav").css("opacity", "0");
    });
  }

  /* SubMenu
  Accordion JS */
  (function ($) {
    $(function () {
      var navLink = false;
      $(".accordion-toggle").on("mousedown", function (e) {
        "use strict";

        e.stopImmediatePropagation();
        if ($(this).parent("div").hasClass("footer-links")) {
          if ($(window).width() < 601) {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content").slideUp(300);
            } else {
              $(".accordion-toggle").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").slideDown(300);
            }
          }
        } else {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content").slideUp(300);
          } else {
            $(".accordion-toggle").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content").slideUp(300);
            $(this).siblings(".accordion-content").slideDown(300);
          }
        }
        navLink = true;
      }).focus(function (e) {
        "use strict";

        if (navLink) {
          navLink = false;
        } else {
          if ($(this).parent("div").hasClass("footer-links")) {
            if ($(window).width() < 601) {
              if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).siblings(".accordion-content").slideUp(300);
              } else {
                $(".accordion-toggle").removeClass("active");
                $(this).addClass("active");
                $(".accordion-content").slideUp(300);
                $(this).siblings(".accordion-content").slideDown(300);
              }
            }
          } else {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content").slideUp(300);
            } else {
              $(".accordion-toggle").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").slideDown(300);
            }
          }
        }
      });
    });
    $(function () {
      var navLink = false;
      $(".accordion-toggle-inner").on("mousedown", function (e) {
        "use strict";

        e.stopImmediatePropagation();
        if ($(this).parent("div").hasClass("footer-links")) {
          if ($(window).width() < 601) {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content-inner").slideUp(300);
            } else {
              $(".accordion-toggle-inner").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content-inner").slideUp(300);
              $(this).siblings(".accordion-content-inner").slideDown(300);
            }
          }
        } else {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content-inner").slideUp(300);
          } else {
            $(".accordion-toggle-inner").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content-inner").slideUp(300);
            $(this).siblings(".accordion-content-inner").slideDown(300);
          }
        }
        navLink = true;
      }).focus(function (e) {
        "use strict";

        if (navLink) {
          navLink = false;
        } else {
          if ($(this).parent("div").hasClass("footer-links")) {
            if ($(window).width() < 601) {
              if ($(this).hasClass("active")) {
                $(this).removeClass("active");
                $(this).siblings(".accordion-content-inner").slideUp(300);
              } else {
                $(".accordion-toggle-inner").removeClass("active");
                $(this).addClass("active");
                $(".accordion-content-inner").slideUp(300);
                $(this).siblings(".accordion-content-inner").slideDown(300);
              }
            }
          } else {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content-inner").slideUp(300);
            } else {
              $(".accordion-toggle-inner").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content-inner").slideUp(300);
              $(this).siblings(".accordion-content-inner").slideDown(300);
            }
          }
        }
      });
    });
  })(jQuery);

  /** HEADER **/
  /** Top Search Result Open Close **/
  $("#searchOpen").on("click", function () {
    $(".js__header-search").toggleClass("active");
    $("#js__header").toggleClass("active");
  });
});

/** Fix Header on Scroll **/
document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    // var scrollHeight = document.querySelector(".announcement-bar").offsetHeight;
    var scrollHeight = 34;
    if (window.scrollY > scrollHeight) {
      document.getElementById("js__header").classList.add("fixed");
      // add padding top to show content behind navbar
      document.body.style.paddingTop = scrollHeight + "px";
      document.body.classList.add("header-fixed");
    } else {
      document.getElementById("js__header").classList.remove("fixed");
      // remove padding top from body
      document.body.style.paddingTop = "0";
      document.body.classList.remove("header-fixed");
    }
  });
});
(function ($) {
  $(window).scroll(function () {
    if ($("body").hasClass("announcement-visible")) {
      var i = $(window).scrollTop();
      var j = 34 - i;
      if (i < 34) {
        $(".template-index .main-header").css("top", j);
        $(".template-404 .main-header").css("top", j);
        $(".inner-hero-page .main-header").css("top", j);
      }
    }
  });
})(jQuery);

/** Mobile Navigation Open Close **/
(function ($) {
  $(function () {
    var navLink = false;
    $("#hamburger").mousedown(function (e) {
      if ($(this).hasClass("active")) {
        $(".boost-pfs-search-suggestion").addClass("hide-boost");
      } else {
        $(".boost-pfs-search-suggestion").removeClass("hide-boost");
      }
      $(this).toggleClass("active");
      $("#navbarNavDropdown").toggleClass("active");
      $("#js__header").toggleClass("active");
      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        if ($(this).hasClass("active")) {
          $(".boost-pfs-search-suggestion").addClass("hide-boost");
        } else {
          $(".boost-pfs-search-suggestion").removeClass("hide-boost");
        }
        $(this).toggleClass("active");
        $("#navbarNavDropdown").toggleClass("active");
        $("#js__header").toggleClass("active");
      }
    });
  });
})(jQuery);

/** CART SIDEBAR
 * Close on Outside Click
 * **/
$(document).mouseup(function (e) {
  var popup = $("#CartSidebar");
  var overlay = $("#cart_overlay");
  if (!popup.is(e.target) && popup.has(e.target).length == 0) {
    popup.removeClass("active");
    overlay.removeClass("active");
    $("#js__header").removeClass("cart-active");
  }
});
"use strict";

var pdpThumbnail;
var pdpSlider;
$(document).ready(function ($) {
  /*Slider working Start*/
  /* Main SLIDER  initialization */
  /*  $(".pdp-slider")
        .not(".slick-initialized")
        .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            focusOnSelect: true,
            infinite: false,
            adaptiveHeight: false,
            variableWidth: false
        });
          
    if (getglobalLib("PDP_Slider_Thumbnail") == "vertical") {
        $(".js__pdp-thumbnail-slider")
            .not(".slick-initialized")
            .slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: false,
                centerMode: false,
                infinite: false,
                focusOnSelect: true,
                focusOnChange: false,
                variableWidth: false,
                verticalSwiping: true,
                vertical: true,
               
                arrows: true,
                responsive: [{
                        breakpoint: 981,
                        settings: {
                            verticalSwiping: false,
                            vertical: false,
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            verticalSwiping: false,
                            vertical: false,
                            variableWidth: true,
                        },
                    },
                ],
            });
    } else {
        $(".js__pdp-thumbnail-slider")
            .not(".slick-initialized")
            .slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                dots: false,
                centerMode: false,
                infinite: false,
                arrows: false,
                focusOnSelect: true,
                variableWidth: false,
              
                responsive: [{
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                    },
                }, ],
            });
    }
    */

  if (getglobalLib("PDP_Slider_Thumbnail") == "vertical") {
    pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
      slidesPerView: 3,
      resistance: false,
      shortSwipes: false,
      clickable: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      draggable: true,
      navigation: {
        nextEl: ".swiper-button-next-pdp",
        prevEl: ".swiper-button-prev-pdp"
      },
      breakpoints: {
        980: {
          slidesPerView: "auto",
          direction: "horizontal"
        },
        981: {
          slidesPerView: 6,
          direction: "vertical"
        }
      }
    });
  } else {
    pdpThumbnail = new Swiper(".js__pdp-thumbnail-slider", {
      resistance: false,
      shortSwipes: false,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      clickable: true,
      grabCursor: true,
      mousewheel: true,
      navigation: {
        nextEl: ".swiper-button-next-pdp",
        prevEl: ".swiper-button-prev-pdp"
      }
    });
  }
  pdpSlider = new Swiper(".js__pdp-slider", {
    slidesPerView: 1,
    grabCursor: false,
    mousewheel: false,
    clickable: false,
    resistance: false,
    shortSwipes: false,
    thumbs: {
      swiper: pdpThumbnail
    }
  });
  var swiperNextCount = 0;
  $(document).on("click", ".swiper-button-next-pdp.swiper-button-disabled", function (e) {
    var count = 1;
    swiperNextCount++;
    if (swiperNextCount == 2) {
      console.log("swiper-button-disabled");
      $(".js__pdp-thumbnail  .swiper-slide").each(function (index) {
        console.log(count);
        if (count == 1) {
          var slideno = parseInt($(this).attr("aria-label").split("/")[0].trim()) - 1;
          pdpThumbnail.slideTo(slideno, 500, true);
          swiperNextCount = 0;
        }
        count++;
      });
    }
  });

  /*PDP tab section drop down change*/
  $(".js__pdp-tab-select").change(function () {
    $(".tab-content").removeClass("active");
    $(".tab-content").hide();
    $("#" + $(this).val()).show();
    $("#" + $(this).val()).addClass("active");
    $(".tab-link").removeClass("active");
    $("#tab-link-" + $(this).val()).addClass("active");
  });

  /* Manual click of thumbnail of slider*/
  $(document).on("click", ".pdp-thumbnail .swiper-slide", function (e) {
    console.log("edeefeff");
    e.preventDefault();
    var slideno = parseInt($(this).attr("aria-label").split("/")[0].trim()) - 1;
    $(".pdp-thumbnail .swiper-slide").removeClass("active");
    $(this).addClass("active");
    pdpSlider.slideTo(slideno, 500, true);
    // $(".pdp-slider").slick("slickGoTo", slideno);
  });

  /*Write review click*/
  $(".js__write-review-btn").click(function () {
    var target = $(".pdp-review-widget");
    setTimeout(function () {
      $("html, body").animate({
        scrollTop: target.offset().top - 200
      }, 500);
    }, 500);
  });
  /*View details*/
  $(document).on("click", ".js__pdp-view-details", function (e) {
    e.preventDefault();
    $(".tab-link").removeClass("active");
    $(".tab-head li:first-child").children(".tab-link").addClass("active");
    $(".tab-content").removeClass("active");
    $(".tab-content:first-child").addClass("active");
    $(".tab-content").hide();
    $(".tab-content:first-child").show();
    $(".js__pdp-tab-select").val($(".tab-head li:first-child").children(".tab-link").attr("data-attr"));
    setTimeout(function () {
      var target = $(".tab-content:first-child");
      $("html, body").animate({
        scrollTop: target.offset().top - 350
      }, 500);
    }, 500);
  });

  /*Slider working End*/
  /* Call page load functions */
  setTimeout(function () {
    setColorThumbImages();
  }, 1000);
  /* FORMATTING: Loop Through each color thumb and set the images for them through the product color library object */
  function setColorThumbImages() {
    if ($(".js-variant-color-swatch li")[0]) {
      $(".js-variant-color-swatch  li").each(function (index) {
        var color = $(this).attr("data-color");
        var colorValue = getVariantColor(color);
        //$(this).children("div.color").css("background-color", colorValue);
        if (colorValue == "") {
          $(this).children("img").css("opacity", "0");
        }
        $(this).children("img").attr("src", colorValue);
      });
    }
  }
});
/*PENDING Get Variant Color*/
function getVariantColor(color) {
  try {
    var variantColorValue = "";
    $.each(prodColor, function (key, value) {
      if (color.toLowerCase() == value.title.toLowerCase()) {
        variantColorValue = value.color;
      }
    });
    /* $.each(prodLib, function (key, value) {
       if (color.toLowerCase() == value.option1.toLowerCase()) {
         variantColorValue = value.image;
       }
     });*/
    return variantColorValue;
  } catch {}
}
/* Color swatch click*/
$(document).ready(function ($) {
  $(document).on("mouseenter", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var variantImage = $(this).attr("data-image");
    var featuredImage = $(this).attr("data-featured_image");
    if (variantImage.indexOf("no-image-") == -1) {
      $(".js__product-image-" + productID).attr("src", variantImage);
    } else {
      $(".js__product-image-" + productID).attr("src", featuredImage);
    }
  });
  $(document).on("mouseleave", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var featuredImage = $(".js__product-image-" + productID).attr("data-src");
    $(".js__product-image-" + productID).attr("src", featuredImage);
  });
  $(document).on("click", ".js__card-add-to-cart", function (e) {
    var selectedVariantID = $(this).attr("data-variant-id");
    var quantity = 1;
    let items = [];

    /* For the main item */
    items.push({
      id: selectedVariantID,
      quantity: quantity
    });
    CartJS.addItems(items, {
      success: function (response, textStatus, jqXHR) {
        $(".modal-quick-view").hide();
        if (getglobalLib("Mini_Cart") == "yes") {
          /* Show message */
          setTimeout(openMiniCart, 500);
        } else {
          window.location = "/cart";
        }
      },
      // Define an error callback to display an error message.
      error: function (jqXHR, textStatus, errorThrown) {
        showCartErrorMessage();
      }
    });
  });
});
"use strict";

var colorSelected = "";
var secondOptionVariantValue = "";
var thirdOptionVariantValue = "";
var selectedVariantID;
$(document).ready(function ($) {
  /* if no varient then active class added in product image section*/
  try {
    if (prodLib.length == 0) {
      $(".js-pdp-media").addClass("active");
      $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
    }
  } catch {}
  var colorPosition = $("#colorPosition").val();
  var numberOfAvailableOptions = parseInt($("#optionSize").val());

  // on page load check the color position, and set 2nd and 3rd options values
  checkColorPosition();
  function checkColorPosition() {
    getColorPosition();
    /* 
    if only color and no other options
    */
    if (colorPosition != undefined && numberOfAvailableOptions == 1) {
      SoldOutUnavailableOnColorSwatches(colorSelected);
    }
  }

  /*
  PENDING Merge  - Plus and Minus
  */

  /*Quantity Plus Minus*/
  $(".js-product-single__quantity .js-plus-minus-qty").click(function () {
    var type = $(this).attr("data-type");
    var productQuantity = $(".js-quantity-selector").val();
    if (type == "minus") {
      if (productQuantity > 1) {
        productQuantity--;
      }
    } else {
      productQuantity++;
    }
    $(".js-quantity-selector").val(productQuantity);
  });

  // On DD change, fire the form DD element and also run the soldoutColorSwatches function
  // $(".js__pdp-variant-select").change(function () {

  $(document).on("change", ".js__pdp-variant-select", function () {
    var optionIndex = $(this).attr("data-option");
    var optionValue = $(this).val();
    $("#product .product__form .options .option.option-" + optionIndex + " .label span").text(optionValue);
    // button  - Sold out and add to cart
    $("#product-select-option-" + optionIndex).val(optionValue).trigger("change");
    //color swatch - sold out working
    SoldOutUnavailableOnColorSwatches(colorSelected);
  });
  // main sold out and unavailable working
  function SoldOutUnavailableOnColorSwatches(colorSelected) {
    getColorPosition();

    // Remove out of stock and unavailable from color swatches
    $(".js__color-swatches").removeClass("out-of-stock");
    $(".js__color-swatches").removeClass("unavailable");
    var colorLength = $(".js__color-swatches").length;
    var colorCount = 1;
    /*
    Loop Through each input radio for the color
    */

    // we are using color swatch working for other options when they are radio buttons
    $(".js__color-swatches").each(function (index) {
      var colorValue = $(this).attr("data-value");
      var checkColorOptionExists = false;
      /* 
       Loop through product library object for variant 
       and if variant select matches and quantity = 0 then show out of stock message
       */

      /*
      PENDING - Merge - ProdLib Each Function
      */

      $.each(prodLib, function (key, value) {
        let itemQuantity = value.quantity;
        let itemAvailable = value.available;
        var prodColorOptionValue = "";
        var prodSecondOptionValue = "";
        var prodThirdOptionValue = "";
        if (colorPosition == "1") {
          prodColorOptionValue = value.option1;
          prodSecondOptionValue = value.option2;
          prodThirdOptionValue = value.option3;
        }
        if (colorPosition == "2") {
          prodColorOptionValue = value.option2;
          prodSecondOptionValue = value.option1;
          prodThirdOptionValue = value.option3;
        }
        if (colorPosition == "3") {
          prodColorOptionValue = value.option3;
          prodSecondOptionValue = value.option1;
          prodThirdOptionValue = value.option2;
        }
        var colorOption = prodColorOptionValue.toLowerCase();
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
        // Pending - Reduce these 3 lines
        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        /*Checking each color  size quantity and which have 0 then added out of stock class*/
        if (numberOfAvailableOptions == 3) {
          /*three matching option checking quantity if 0 then showing out of stock */
          if (secondOptionVariantValue.toLowerCase() == prodSecondOptionValue.toLowerCase() && thirdOptionVariantValue.toLowerCase() == prodThirdOptionValue.toLowerCase()) {
            {
              //check if quantity>1 then set the color swatch - Out of stock
              setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
            }
          }
        } else if (numberOfAvailableOptions == 2) {
          /*two matching option checking quantity if 0 then showing out of stock */
          if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
            {
              //check if quantity>1 then set the color swatch - Out of stock
              setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
            }
          }
        } else {
          //check if quantity>1 then set the color swatch - Out of stock
          setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
        }
        if (prodColorOptionValue == colorValue) {
          if (numberOfAvailableOptions == 3) {
            if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase() && prodThirdOptionValue.toLowerCase() == thirdOptionVariantValue.toLowerCase()) {
              checkColorOptionExists = true;
            }
          } else if (numberOfAvailableOptions == 2) {
            if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
              checkColorOptionExists = true;
            }
          } else {
            checkColorOptionExists = true;
          }
        }
      });
      if (checkColorOptionExists == false) {
        var colorOption = colorValue;
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        colorOption = colorOption.toLowerCase();
        $(".js__color-swatches[data-type-value=" + colorOption + "]").removeClass("out-of-stock");
        $(".js__color-swatches[data-type-value=" + colorOption + "]").addClass("unavailable");
        if ($(".js__color-swatches[data-type-value=" + colorOption + "]").hasClass("active")) {
          var nextColor = colorCount + 1;
          if (colorCount < colorLength) {
            $(".js__color-swatches:nth-child(" + nextColor + ")").click();
          } else {
            $(".js__color-swatches:nth-child(1)").click();
          }
        }
      }
      colorCount++;
    });
  }
  function getColorPosition() {
    if (colorPosition != undefined && numberOfAvailableOptions > 1) {
      if (colorPosition == "1") {
        secondOptionVariantValue = $(".js__pdp-variant-select1").val();
        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select2").val();
        }
      }
      if (colorPosition == "2") {
        secondOptionVariantValue = $(".js__pdp-variant-select0").val();
        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select2").val();
        }
      }
      if (colorPosition == "3") {
        secondOptionVariantValue = $(".js__pdp-variant-select0").val();
        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select1").val();
        }
      }
    } else {
      secondOptionVariantValue = $(".js__pdp-variant-select0").val();
      if (numberOfAvailableOptions > 1) {
        thirdOptionVariantValue = $(".js__pdp-variant-select1").val();
      }
    }
    try {
      colorSelected = colorSelected.toLowerCase();
    } catch {}
  }
  function setColorSwatchOutofStock(prodColor, prodQuantity, prodAvailability) {
    if (prodQuantity < 1 && prodAvailability == "false") {
      $(".js__color-swatches[data-type-value=" + prodColor + "]").addClass("out-of-stock");
    }
  }
});